import React from "react";
// import { useContext } from "react";
// import { UserContext } from "../OEMChanges/OemAssetsImport";
import navarrow from "../assets/back_btn.png";

import walletIcon from "../assets/revamp-assets/walletIcon.png"
// import infoIcon from "../assets/revamp-assets/infoIcon.png"
import infoIcon from "../assets/revamp-assets/grey-info-icon.svg"
//grey-info-icon
// import aceStar from '../assets/revamp-assets/aceStar.png'
import NewClose from "../assets/revamp-assets/closeMark.png"
import Cross from '../assets/Redeem-revamp/Cross.svg'
import lock from '../assets/revamp-assets/locked.png';
// import AcePointsStarIcon from '../assets/revamp-assets/StarIcon.svg'
import InfoIcon from '../assets/revamp-assets/InfoIcon.svg'
import SuccessIcon from '../assets/revamp-assets/SuccessIcon.svg'
import CloseIcon from '../assets/revamp-assets/CloseIcon.svg'
import upArrow from "../assets/Redeem-revamp/upArrow.svg";
import downArrow from "../assets/Redeem-revamp/downArrow.svg";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import RedeemInfo from "../models/RedeemInfo";
import CommonAlert from "../models/PKCommonAlert";
import Loading from "../models/Loading"
import { WALLETPAGE_STRINGS, POKER_TDS_INFO, RUPEE_SYMBOL } from "../Strings";
import PokertoA23Trasnfer from '../models/PokertoA23Transfer';
import Progress from "../models/ShowProgress";
import A23ToPokerTransfer from '../models/A23BalanceToPokerTransfer';
import { toggleAlertAction, toggleModalAction, getUserProfileAction, getPokerAmountTDSInfo, pokerAmountToA23Transfer, a23ToPokerAmountTransfer, fetchRedeemAcePointsData, submitClaimRedeemAcePoints } from "../redux/actions/userAction"
// import './WalletInfo.css';
import PremiumAccess from "../models/PremiumAccess";
import { createAdminPageURL, createOEMAdminPageURL, WebToNativeMessage } from "../Common/Utils";
import tstimer from '../assets/ts-timer.png'
import Tooltip from "../Tooltip";
import PendingRedeemIcon from "../assets/pendingRedeemIcon.png";
// import OemRedeemAssets from "../OEMChanges/OEMAssets";

//#region OemAssets

import oemNavArrow from "../OemAssets/BackBtn_withSpacing.svg";
import oemInfoIcon from "../OemAssets/infoIcon.svg";
import oemTransactionIcon from "../OemAssets/transcationSummaryIcon.svg";
import oemWalletIcon from "../OemAssets/WalletIcon.svg";
import oemPendingRedeemIcon from "../OemAssets/PendingRedeemIcon.svg";
import oemCross from '../OemAssets/close.svg';
import oemupArrow from "../OemAssets/upArrow.svg";
import oemdownArrow from "../OemAssets/downArrow.svg";


import { UserContext } from "../OEMChanges/OemAssetsImport";
import { notifyTokenReceived } from "../api/AxiosInstance";
import funChipsReload from '../assets/ReloadButtons.png';
import funChipsIcon from '../assets/chipsIconGold.png';
import gemsIcon from '../assets/diamondImg.png';
import axios from 'axios';
import AddImg from "../assets/addImg.png"
import AdBanner from "../Common/AdBanner";
//  import { VernacularContext, LanguageProvider } from '../OEMChanges/LanguageContext.js';

//#endregion

// console.log("sessionStorage.getItem>>", sessionStorage.getItem("channel"));
// import walletInfoOEMStyle from "./WalletInfoOEM.css"
// import walletInfoStyle from "./WalletInfo.css"


class WalletInfoRevamp extends React.Component {
    // static contextType = VernacularContext;

    constructor(props) {
        super(props)

        // console.log("Context enti >>>", VernacularContext);
        // 
        console.log("What is the channel", sessionStorage.getItem("channel"));
        this.state = {
            allData: {},
            clientObject: {},
            aceLevel: '',
            userBalance: 0,
            cashbonus: 0,
            redeembalance: 0,
            totalPendingRedeems: 0,
            pokerbalance: 0,
            acepointsbalance: 0,
            //netwinnings flag
            showTaxableRunningNetWin: false,
            showNegativeTaxRunningNetWinnings: false,
            taxableRunningNetWin: 0,
            bonusToBeExpired: { amount: null, expiryAt: null },
            expiryDaysLeft: '',
            mobile: "",

            deposits: 0,
            isOem: false,
            lockedbonus: 0,
            // Uncomment bottom two lines when pushing.
            a23token: "",
            token: "",
            channel: "",
            bon: 0,
            win: 0,
            extraCash: 0,
            totalBalance: 0,
            channelCheckForRedeem: false,
            userId: "",
            pendingBonus: 0,
            isLoading: true,
            kycStatus: "",
            totalUserbalance: 0,
            pokerTotal: 0,
            pokerDeposit: 0,
            pokerExtraCash: 0,
            pokerPromo: 0,
            pokerWin: 0,
            pk_panStatus: false,
            pk_amount: 0,
            pk_tdsAmount: 0,
            pk_tdsApplicable: true,
            pk_kycStatus: "",
            pokerAmount: "",
            isPKTransactionInPendingState: false,
            scrollY: 0,
            //reactVersion:'1.0',
            screenName: "",
            isKeyboardVisible: false,
            focus: false,
            errors: {
                message: ""
            },
            //Bonus Cash = bon + extracash
            bonusCash: 0,
            pokerBonusCash: 0,
            subscriptionType: '',
            playerStatus: '',
            showTaxPopup: false,
            transactionsActive: false,
            failedTransactions: false,
            showRedeemAceLevelModal: false,
            showAcePointsRedeemSuccessModal: false,
            showAcePointsValueMultiplesError: false,
            showAcePointsLimitExceeded: false,
            showInsufficientAcePoints: false,
            acePointsToConvert: '',
            enableAcePointsClaimButton: false,
            enableHeader: true,
            redeemAcePointsKeyboardOpen: false,
            showRedeemableBalanceInWalletInfo: false,
            //isA23ToPokerTransferBtnEnable:true,
            showBonusDetailsInRedeemPopUp: false,
            showRedeemableBalancePopUp: false,
            bonusReleasedLastXDaysAmt: 0,
            bonusReleasedLastXDays: 0,
            redeemableAmount: 0,
            bonusReleasedLastXDaysList: [],
            showIframe: false,
            currentFinYear: '',
            openingBalanceFinYear: 0,
            fyYearString: '',
            openRedeemAcepointsInfoPopUp: false,
            acepointsErrorMessage: '',
            minRedeemableValue: 0,
            maxRedeemableValue: 0,
            redeemLimits: {
                "bronze": {
                    "min": 10,
                    "max": 100
                },
                "silver": {
                    "min": 10,
                    "max": 250
                },
                "gold": {
                    "min": 10,
                    "max": 500
                },
                "platinum": {
                    "min": 10,
                    "max": 1000
                },
                "platinum+": {
                    "min": 10,
                    "max": 2500
                }
            },
            bonusExpiryString: "",
            tdsRefundUrl: "",
            downloadfinancialYear: "",
            showTaxableNetWin: false,
            tdsRefundConfig: 0,
            tdsRefundAmount: 0,
            tdsRefundEligibility: 0,
            tdshistoryReportHyperlinkName: "TDS History Report",
            itrReportHyperlinkName: "ITR Report",
            //   isA23Poker:(sessionStorage.getItem("channel") === 'poker2android' || sessionStorage.getItem("channel") === 'poker2ios' || sessionStorage.getItem("channel") === 'poker2freerollAndroid') ? true : false,
            // isAdda: (sessionStorage.getItem("channel").toLowerCase() === 'ipaps' || sessionStorage.getItem("channel").toLowerCase() === 'hps' || sessionStorage.getItem("channel").toLowerCase() === 'ipips' || sessionStorage.getItem("channel").toLowerCase() === 'ipwin' || sessionStorage.getItem("channel").toLowerCase() === 'ipmac') ? true : false ,

            isA23Poker: (sessionStorage.getItem("channel").toLowerCase() === 'ipaps' || sessionStorage.getItem("channel").toLowerCase() === 'hps' || sessionStorage.getItem("channel").toLowerCase() === 'ipips' || sessionStorage.getItem("channel").toLowerCase() === 'ipwin' || sessionStorage.getItem("channel").toLowerCase() === 'ipmac') ? true : false,
            isAdda: (sessionStorage.getItem("channel") === 'poker2android' || sessionStorage.getItem("channel") === 'poker2ios' || sessionStorage.getItem("channel") === 'poker2freerollAndroid') ? true : false,


        }
    }

    // For Poker Input Text Added Changes 
    onKeyUp(event) {
        if (event.keyCode === 13) {
            event.target.blur();
        }
    }

    onChange = e => {
        this.setState({ errors: { message: "" } })
        e.target.value = e.target.value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '')
        if (e.target.value.length === 0) {
            this.setState({ pokerAmount: "" });
        }
        // e.target.value.replace(/[^\w\s]/gi, "");
        var rgx = /^[0-9]+$/;
        if (e.target.value.match(rgx)) {
            this.setState({ pokerAmount: e.target.value });
        }
    }
    //For Submitting Bank details
    isAndroid = () => {
        const ua = navigator.userAgent.toLowerCase() + navigator?.platform.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        return isAndroid;
    }

    handleValidation = () => {
        try {
            if ((this.state.totalUserbalance == "0" || this.state.totalUserbalance < 0 || this.setState.totalUserbalance < 1)) {
                this.setState({
                    errors: {
                        message:
                            `${WALLETPAGE_STRINGS.KEY_PK_INSUFFICIENTBALANCE_ADDCASH}`
                    }
                });
                return false;
            } else if (this.state.pokerAmount == "0" || this.state.pokerAmount.startsWith("0", 0)) {
                this.setState({
                    errors: {
                        message:
                            `${WALLETPAGE_STRINGS.KEY_PK_TRANSFER_ZERO_VALIDATION}`
                    }
                });
                return false;
            }
            else if (this.state.pokerAmount == "null" || this.state.pokerAmount == "" || this.state.pokerAmount < 1) {
                this.setState({
                    errors: {
                        message:
                            `${WALLETPAGE_STRINGS.KEY_PK_AMOUNT_EMPTY_MSG_TV}`
                    }
                });
                return false;
            } else if (isNaN(this.state.pokerAmount) || (this.state.pokerAmount.indexOf('.') !== -1)) {
                this.setState({
                    errors: {
                        message: `${WALLETPAGE_STRINGS.KEY_PK_DECIMAL_MSG_ERROR}`
                    },
                });
                return false
            } else if (this.state.pokerAmount > this.state.totalUserbalance && (this.state.totalUserbalance == "0" || this.state.totalUserbalance < 0)) {
                this.setState({ errors: { message: `${WALLETPAGE_STRINGS.KEY_PK_INSUFFICIENTBALANCE_ADDCASH}` } });
                return false;
            } else if (this.state.pokerAmount > this.state.totalUserbalance) {
                this.setState({ errors: { message: `${WALLETPAGE_STRINGS.KEY_PK_MINIMUM_AMOUNT_ERROR_TV}` + this.state.totalUserbalance } });
                return false;
            } else {
                //this.A23BalanceToPokerTransfer();
                this.props.toggleModalAction(true, <A23ToPokerTransfer amount={this.state.pokerAmount} handleUserTDSInfoRes={() => this.A23BalanceToPokerTransfer()}></A23ToPokerTransfer>);
            }
        } catch (err) {
            console.error(err);
        }
    };

    //handle balance Transfer Resposne
    updateUserBalance = () => {
        this.setState({ isLoading: true });
        this.getProfileDataFromURL("addCash");
        this.setState({ pokerAmount: "", errors: { message: "" } })
    }

    getFormattedDateAndTime = (timeStamp) => {
        // return createdAtDate = epoch.getDay() + ' ' + months[epoch.getMonth()] + ' ' + epoch.getFullYear() + ', ' + epoch.getHours() + ':' + epoch.getMinutes() + ':' + epoch.getSeconds()
        // dd/mm/yyyy hh:mm am/pm
        var a = new Date(timeStamp);
        var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        var year = a.getFullYear();
        // var month = months[a.getMonth()];
        var month = a.getMonth() + 1;
        var date = a.getDate();
        var hour = a.getHours();
        var min = a.getMinutes();
        var ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12;
        hour = hour ? hour : 12; // the hour '0' should be '12'
        min = min < 10 ? "0" + min : min;
        var time =
            date + "/" + month + "/" + year + " " + hour + ":" + min + " " + ampm;
        return time;
    };



    getRedeemAcePointsDetails = async () => {
        const token = window.sessionStorage.getItem("token");
        await this.props.fetchRedeemAcePointsData(token)
        const { redeemAcePointsDetails } = this.props.userState
        this.setState({
            redeemLimits: redeemAcePointsDetails.redeemLimits
        })
    }

    A23BalanceToPokerTransfer = async () => {
        //this.props.toggleModalAction(true,<Progress></Progress>)
        this.setState({ isLoading: true })
        await this.props.a23ToPokerAmountTransfer(this.state.token, "2", this.state.pokerAmount);
        this.setState({ pokerAmount: "" })
        const { a23ToPokerTransferRes } = this.props.userState;
        if (a23ToPokerTransferRes.error) {
            if (a23ToPokerTransferRes.message) {
                this.props.toggleAlertAction(true, a23ToPokerTransferRes.message, 4000, "bg-green");
            } else {
                this.props.toggleAlertAction(true, a23ToPokerTransferRes.error, 4000, "bg-red");
            }
            //this.props.toggleModalAction(false);
            this.setState({ isLoading: false })
        } else {

            if (a23ToPokerTransferRes.status) {
                this.props.toggleAlertAction(true, a23ToPokerTransferRes.message, 4000, "bg-green");
                this.updateUserBalance();
                //this.props.toggleModalAction(false);
            } else {
                this.props.toggleAlertAction(true, a23ToPokerTransferRes.message, 4000, "bg-red");
                this.updateUserBalance();
                // this.props.toggleModalAction(false);
            }
        }
    }
    //Check if given Number is Integer or float
    checkforIntegerNumber = (num) => {
        if (typeof num == 'number' && !isNaN(num)) {
            if (Number.isInteger(num)) {
                return num;
            } else {
                return num.toFixed(2);
            }
        } else {
            return parseInt(num).toFixed(2);
        }
    }

    getProfileDataInWallet = async (object) => {
        let token = window.sessionStorage.getItem("token");
        try {
            let data
            console.log("TRYING TO PARSE DATA")
            // Parsing Data only if Data To Client Message Called
            if (window.sessionStorage["channel"] !== "MHTML" && window.sessionStorage["channel"] !== "ND") {
                console.log("NOT ND CLIENT")
                data = JSON.parse(object)
            } else {
                console.log("IT IS ND CLIENT")
                data = {}
                data.token = window.sessionStorage["token"]
                console.log('data.token is : ', data.token)
            }
            console.log("STATEMENT 3 => ", token)
            await this.props.getUserProfileAction(token)
            console.log("STATEMENT 4")
            const { profileData } = this.props.userState;
            console.log("RECEIVED PROFILE DATA")
            if (profileData.error) {
                this.handleBackBtnClick({ type: "closeClient" })
            } else if (profileData.message && profileData.statusCode) {
                this.handleBackBtnClick({ type: "closeClient" })
            } else {
                console.log("profile data >>>>> getProfileDataInWallet", profileData);
                this.setState({
                    subscriptionType: profileData.subscriptionType,
                    aceLevel: profileData.currentAceLevelName,
                    userBalance: profileData.total,
                    acepointsbalance: profileData.currentTotalAcePoints,
                    totalPendingRedeems: profileData.totalPendingRedeems,
                    mobile: profileData.mobile,
                    cashbonus: profileData.bon,
                    win: profileData.win,
                    deposits: profileData.tnx,
                    extraCash: profileData.extraCash,
                    bon: profileData.bon,
                    bonusToBeExpired: profileData.bonusToBeExpired,
                    expiryDaysLeft: this.calculateDaysLeft(profileData.bonusToBeExpired.expiryAt),
                    userId: profileData._id,
                    pendingBonus: profileData.pending_bonus,
                    isLoading: false,
                    kycStatus: profileData.kycStatus,
                    totalUserbalance: profileData.total,
                    pokerTotal: profileData.pokerTotal,
                    pokerDeposit: profileData.pokerDeposit,
                    pokerWin: profileData.pokerWin,
                    pokerExtraCash: profileData.pokerExtraCash,
                    pokerPromo: profileData.pokerPromo,
                    isPKTransactionInPendingState: profileData.isPokerTransactionInProcess,
                    screenName: profileData.screenName,
                    subscriptionType: profileData.subscriptionType,
                    playerStatus: profileData.playerStatus,
                    //netwinnings flag
                    showTaxableRunningNetWin: profileData.showTaxableRunningNetWin,
                    taxableRunningNetWin: profileData.taxableRunningNetWin,
                    netWinnings: profileData.netWinnings,
                    tdsPaidNetWinning: profileData.taxedNetWinning,
                    totalTaxPaid: profileData.totalTaxPaid,
                    showNegativeTaxRunningNetWinnings: profileData.showNegativeTaxRunningNetWinnings,
                    showRedeemableBalanceInWalletInfo: profileData.enablebonusReleasedLastXDays,  //should add key from profiledata
                    bonusReleasedLastXDaysAmt: profileData.bonusReleasedLastXDaysAmt,
                    bonusReleasedLastXDays: profileData.bonusReleasedLastXDays,
                    redeemableAmount: profileData.redeemableAmount,
                    bonusReleasedLastXDaysList: profileData.bonusReleasedLastXDaysList,
                    currentFinYear: profileData.currentFinYear,
                    openingBalanceFinYear: profileData.openingBalanceFinYear,
                    fyYearString: profileData.fyYearString,

                    //bonusExpiryString
                    bonusExpiryString: profileData.bonusExpiryString,
                    tdsRefundUrl: profileData.tdsRefundUrl,
                    downloadfinancialYear: profileData.tdsRefundFinYear,
                    showTaxableNetWin: profileData.showTaxableNetWin,

                    tdshistoryReportHyperlinkName: profileData.tdshistoryReportHyperlinkName,
                    itrReportHyperlinkName: profileData.itrReportHyperlinkName,
                    funBalance: profileData.funBalance,
                    gems: profileData.gems,

                    // 

                    tdsRefundConfig: profileData.tdsRefundConfig ? profileData.tdsRefundConfig : 0,
                    tdsRefundAmount: profileData.tdsRefundAmount ? profileData.tdsRefundAmount : 0,
                    tdsRefundEligibility: profileData.tdsRefundEligibility ? profileData.tdsRefundEligibility : 0,

                })
                console.log("SET ALL PROFILE STATES")
                window.sessionStorage["mobile"] = this.state.mobile
                window.sessionStorage["userid"] = this.state.userId;
                window.sessionStorage["kycStatus"] = this.state.kycStatus;
                var screenValue = "";
                if (data.channel == "A23APS" || data.channel == "A23IPS") {
                    screenValue = "P_MyWallet";
                } else if (data.channel == "FAPS" || data.channel == "FIPS") {
                    screenValue = "FS_P_MyWallet";
                } else {
                    screenValue = "R_MyWallet"
                }
                if (window.sessionStorage !== undefined) {
                    WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
                }
            }

            console.log("STATEMENT 5 ddddddd", this.state.win)
            let Redeembalance = this.state.win
            let bonusCash = this.state.extraCash //+ this.state.cashbonus
            let pkbonusCash = this.state.pokerExtraCash + this.state.pokerPromo
            console.log("SETTING STATES AGAIN")
            this.setState({ redeembalance: this.state.win, bonusCash: bonusCash.toFixed(2), pokerBonusCash: pkbonusCash.toFixed(2) })
            this.setState({ token: data.token, a23token: data.a23Token, channel: data.channel, channelCheckForRedeem: data.channelCheckForRedeem })
            this.getRedeemAcePointsDetails()
            console.log("SETTING STATES AGAIN COMPLETED")
        } catch (err) {
            console.log('Error in walletInfoRevamp');
        }


        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_mywallet_pageview", eventProperties: {
                aceLevel: this.state.aceLevel,
                Acepoints_balance: this.state.acepointsbalance,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],//this.state.channel,
                winnings_balance: this.state.redeembalance,
                bonuscash_balance: this.state.bon,
                locked_bonus: this.state.lockedbonus,
                deposits_balance: this.state.deposits,
                wallet_balance: this.state.totalUserbalance,
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName,
                tdsRefundConfig: this.state.tdsRefundConfig,
                tdsRefundEligibility: this.state.tdsRefundEligibility,
                tdsRefundAmount: this.state.tdsRefundAmount,
                timestamp: new Date().getTime()
            }
        })


        WebToNativeMessage({
            type: "plotlineEvent", eventName: "PF_c_mywallet_pageview", eventProperties: {
                aceLevel: this.state.aceLevel,
                Acepoints_balance: this.state.acepointsbalance,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],
                winnings_balance: this.state.redeembalance,
                bonuscash_balance: this.state.bon,
                locked_bonus: this.state.lockedbonus,
                deposits_balance: this.state.deposits,
                wallet_balance: this.state.totalUserbalance,
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName,
                tdsRefundConfig: this.state.tdsRefundConfig,
                tdsRefundEligibility: this.state.tdsRefundEligibility,
                tdsRefundAmount: this.state.tdsRefundAmount,
                timestamp: new Date().getTime()
            }
        })


        WebToNativeMessage({
            type: "mixpanelEvent", eventName: "PF_c_mywallet_pageview", eventProperties: {
                aceLevel: this.state.aceLevel,
                Acepoints_balance: this.state.acepointsbalance,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],
                winnings_balance: this.state.redeembalance,
                bonuscash_balance: this.state.bon,
                locked_bonus: this.state.lockedbonus,
                deposits_balance: this.state.deposits,
                wallet_balance: this.state.totalUserbalance,
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName,
                tdsRefundConfig: this.state.tdsRefundConfig,
                tdsRefundEligibility: this.state.tdsRefundEligibility,
                tdsRefundAmount: this.state.tdsRefundAmount,
                timestamp: new Date().getTime()
            }
        })
    }

    handleRedeemInfo = () => {
        window.sessionStorage.setItem('policyBack', 'walletinfo')
        // this.props.history.push("/redeeminfo/");
        WebToNativeMessage({ type: 'openRedeemPolicy' });
        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_Click_mywallet_winningsmoreinfo", eventProperties: {
                aceLevel: this.state.aceLevel,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName
            }
        })
    };

    createRedeemAcepointsInfoPopUp = () => {
        return (
            <div className="redeemAcepointsInfoPopupMain"
            //  style={{ position: 'absolute', width: "100%", height: '100%', top: "0", left: "0", display: "flex", alignItems: "center", justifyContent: "center", zIndex: '100110001' }}
            >
                <div id="modalBackgroundRedeemAcepointsInfoPopup" className="modalBackgroundRedeemAcepointsInfoPopup"
                    //  style={{ position: "absolute", width: "100%", height: "100%", background: "rgba(0,0,0,0.5)" }}
                    onClick={() => {
                        this.setState({
                            openRedeemAcepointsInfoPopUp: false
                        })
                    }}></div>
                <div id="redeem-acepoints-info-pop-up" className="redeem-acepoints-info-pop-up"
                //  style={{ position: "absolute", maxWidth: "500px", width: "95%", height: "45%", display: "flex", alignItems: "center", justifyContent: 'center', flexDirection: "column", borderRadius: '5px' }}
                >
                    <div className="redeem-acepoints-info-header"
                    //  style={{ width: "100%", height: "12%", color: '#FFFFFF', fontSize: '1rem', fontWeight: '700', background: '#2C5391', borderRadius: '5px 5px 0px 0px', display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        Redeem Ace Points
                        <img src={Cross} className="apCross"
                            //  style={{ position: "absolute", right: "15px" }} 
                            onClick={() => {
                                this.setState({
                                    openRedeemAcepointsInfoPopUp: false
                                })
                            }} />
                    </div>
                    <div className="redeem-acepoints-info-body"
                    //  style={{ display: 'flex', alignItems: "center", justifyContent: 'center', width: "100%", height: '88%', background: "#F9F9F9", flexDirection: 'column', justifyContent: "space-evenly", borderRadius: "0px 0px 5px 5px" }}
                    >
                        <div className="redeemacepointsinfobody1"
                        // style={{ width: '90%', color: "#032146", textAlign: "center", fontSize: "0.9rem", fontWeight: '700' }}
                        >AcePoints Redeem limits by AceLevel</div>
                        <div
                            //  style={{ display: "flex", flexDirection: "column", width: "80%", color: "#032146", background: '#FFFFFF', borderRadius: "5px", border: '1px solid #adc0de' }} 
                            className="redeem-acepoints-info-table">
                            <div
                                // style={{ width: "100%", height: "fit-content", minHeight: '40px', display: 'flex', alignItems: "center", justifyContent: "space-evenly", background: "#c4d1e6", fontSize: '0.9rem', fontWeight: "700", borderRadius: '4px 4px 0px 0px' }}
                                className="redeem-acepoints-info-table1" >
                                <span
                                    // style={{ width: "25%", textAlign: 'center' }}
                                    className="redeem-acepoints-info-table11" >Ace Level</span>
                                <span

                                    className="redeem-acepoints-info-table12" >Redeem Limit per Validity Period</span>
                                <span className="redeem-acepoints-info-table12">Min. Redeem Request</span>
                            </div>
                            {Object.keys(this.state.redeemLimits).map((item) => {

                                return (
                                    <div className="redeem-acepoints-info-item" key={item}
                                    >
                                        <span className="redeem-acepoints-info-table11">{item[0].toUpperCase() + item.slice(1)}</span>
                                        <span className="redeem-acepoints-info-table12">{this.state.redeemLimits[item].max}</span>
                                        <span className="redeem-acepoints-info-table12">{this.state.redeemLimits[item].min}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    async componentWillMount() {
        window.sessionStorage.setItem("isfrom", "wallet")
        const searchParams = (window.location.href).split('enableHeader=')[1]
        this.setState({
            enableHeader: searchParams,
        })
        this.setState({
            isOem: sessionStorage.getItem("channel") === 'OEMAPS1'
        })
    }



    async componentDidMount() {
        WebToNativeMessage({ "type": "ScreenNameEventForUXCam", "screenName": "My_Wallet_Page" }) //for UXCam
        console.log("Session Storage Client Data: ", window.sessionStorage["clientData"])
        // Checking if there is ace points tool tip data in localStorage
        if (window.localStorage["acepoints-redeem-object"] !== undefined && window.localStorage["acepoints-redeem-object"] !== null) {
            // If the data exists, we need to see if existing user has logged in on this client before or not
            let acePointsTooltipData = JSON.parse(window.localStorage["acepoints-redeem-object"])
            let userTooltipData = acePointsTooltipData.filter(item => item.username === window.sessionStorage["screenName"])
            if (userTooltipData.length !== 0) {
                // If the user did log in on this client before, we are increasing their count by 1
                userTooltipData[0].count += 1
            } else {
                // If the current user did not log in to this client, we are creating a new object for this user
                let newObject = {
                    username: window.sessionStorage["screenName"],
                    count: 1
                }
                // Pushing this users data to the ace points tool tip data
                acePointsTooltipData.push(newObject)
            }
            // Saving the data in localStorage
            window.localStorage["acepoints-redeem-object"] = JSON.stringify(acePointsTooltipData)
        } else {
            // Creating a new object for ace points tool tip data with current user details and count
            window.localStorage["acepoints-redeem-object"] = JSON.stringify(
                [{
                    username: window.sessionStorage["screenName"],
                    count: 1
                }]
            )
        }
        const data = JSON.parse(window.sessionStorage["clientData"]);
        console.log(data, " is client data in wallet info");
        window.sessionStorage.setItem("isNewVersion", data.isNewVersion);

        console.log(window.sessionStorage.getItem("isNewVersion"), "from client data isNewVersion in wallet info");

        if (window.sessionStorage["token"] !== undefined) {
            this.getProfileDataInWallet(window.sessionStorage["clientData"])
        } else {
            this.getProfileDataFromURL(window.sessionStorage["type"])
        }
        try {
            window.dataToClient = async (message) => {
                let parsedMessage = JSON.parse(message)
                console.log('CDM message 2', message)
                window.sessionStorage.setItem("isNewVersion", parsedMessage.isNewVersion);
                if (parsedMessage.type && parsedMessage.type.toLowerCase() === "updatedtoken") {
                    console.log("Updated Token received from Native: ", parsedMessage.token);
                    let clientData = JSON.parse(window.sessionStorage.getItem("clientData"));
                    console.log("clientData before setting token: ", clientData);
                    if (clientData) {
                        clientData.token = parsedMessage.token;
                        clientData.a23Token = parsedMessage.a23Token;
                        console.log("setting clientData in sessionStorage: ", JSON.stringify(clientData));
                        window.sessionStorage.setItem("clientData", JSON.stringify(clientData))
                    }
                    window.sessionStorage.setItem("token", parsedMessage.token);
                    window.sessionStorage.setItem("a23token", parsedMessage.a23Token);
                    notifyTokenReceived(parsedMessage.token);
                    return;
                }

                if (parsedMessage.proceedToRedeemPageAdFlow) {
                    console.log("Proceed to redeem flow confirmation received");
                    this.props.history.push({
                        pathname: "/redeem/",
                        token: window.sessionStorage["token"],
                        from: "wallet"
                    });
                }
                // window.sessionStorage.setItem("pushNotificationEnable", parsedMessage.pushNotificationEnable);
                if (parsedMessage && parsedMessage?.type === 'onbackpressed') {
                    this.handleAcePointsBlurChange()
                }
            }
        } catch (e) { }
        // console.log("channel from Client>>>",sessionStorage.getItem("channel"))
        // if(sessionStorage.getItem("channel") === "OEMAPS1"){
        //     require('./WalletInfoOEM.css');
        // }else{
        //     require('./WalletInfo.css');
        // }

    }

    getProfileDataFromURL = async (type) => {
        // Uncomment bottom two brackets on push
        console.log("getProfileDataFromURL called with type: ", type);
        if (window.sessionStorage["token"] !== undefined) {
            if (this.state.token === "" || type === "addCash") {
                this.setState({ isLoading: true })
                await this.props.getUserProfileAction(window.sessionStorage["token"])
                const { profileData } = this.props.userState;
                console.log("Wallet response::::", profileData);
                this.setState({
                    subscriptionType: profileData.subscriptionType,
                    playerStatus: profileData.playerStatus,
                    aceLevel: profileData.currentAceLevelName,
                })
                console.log('SUBSCRIPTION TYPE IS SET TO:', profileData.subscriptionType)
                console.log('PLAYER_STATUS TYPE IS SET TO:', profileData.playerStatus)
                if (profileData.error) {
                    this.handleBackBtnClick({ type: "closeClient" })
                } else if (profileData.message && profileData.statusCode) {
                    this.handleBackBtnClick({ type: "closeClient" })
                } else {
                    console.log("profile data >>>>> getProfileDataFromURL", profileData);
                    this.setState({
                        userBalance: profileData.total,
                        acepointsbalance: profileData.currentTotalAcePoints,
                        mobile: profileData.mobile,
                        cashbonus: profileData.bon,
                        win: profileData.win,
                        deposits: profileData.tnx,
                        extraCash: profileData.extraCash,
                        bonusToBeExpired: profileData.bonusToBeExpired,
                        expiryDaysLeft: this.calculateDaysLeft(profileData.bonusToBeExpired.expiryAt),
                        bon: profileData.bon,
                        userId: profileData._id,
                        pendingBonus: profileData.pending_bonus,
                        isLoading: false,
                        kycStatus: profileData.kycStatus,
                        totalUserbalance: profileData.total,
                        pokerTotal: profileData.pokerTotal,
                        pokerDeposit: profileData.pokerDeposit,
                        pokerWin: profileData.pokerWin,
                        pokerExtraCash: profileData.pokerExtraCash,
                        pokerPromo: profileData.pokerPromo,
                        isPKTransactionInPendingState: profileData.isPokerTransactionInProcess,
                        screenName: profileData.screenName,
                        aceLevel: profileData.currentAceLevelName,
                        //netwinnings flag
                        showTaxableRunningNetWin: profileData.showTaxableRunningNetWin,
                        taxableRunningNetWin: profileData.taxableRunningNetWin,
                        netWinnings: profileData.netWinnings,
                        tdsPaidNetWinning: profileData.taxedNetWinning,
                        totalTaxPaid: profileData.totalTaxPaid,
                        showNegativeTaxRunningNetWinnings: profileData.showNegativeTaxRunningNetWinnings,
                        showRedeemableBalanceInWalletInfo: profileData.enablebonusReleasedLastXDays,  //should add key from profiledata
                        bonusReleasedLastXDaysAmt: profileData.bonusReleasedLastXDaysAmt,
                        bonusReleasedLastXDays: profileData.bonusReleasedLastXDays,
                        redeemableAmount: profileData.redeemableAmount,
                        bonusReleasedLastXDaysList: profileData.bonusReleasedLastXDaysList,
                        currentFinYear: profileData.currentFinYear,
                        openingBalanceFinYear: profileData.openingBalanceFinYear,
                        fyYearString: profileData.fyYearString,
                        //bonusExpiryString
                        bonusExpiryString: profileData.bonusExpiryString,
                        tdsRefundUrl: profileData.tdsRefundUrl,
                        downloadfinancialYear: profileData.tdsRefundFinYear,
                        showTaxableNetWin: profileData.showTaxableNetWin,
                        tdshistoryReportHyperlinkName: profileData.tdshistoryReportHyperlinkName,
                        itrReportHyperlinkName: profileData.itrReportHyperlinkName,
                        funBalance: profileData.funBalance,
                        gems: profileData.gems,
                    })
                    if (type == "") {
                        var screenValue = "";
                        if (window.sessionStorage["channel"] == "A23APS" || window.sessionStorage["channel"] == "A23IPS") {
                            screenValue = "P_MyWallet";
                        } else if (window.sessionStorage["channel"] == "FAPS" || window.sessionStorage["channel"] == "FIPS") {
                            screenValue = "FS_P_MyWallet";
                        } else {
                            screenValue = "R_MyWallet"
                        }
                        if (window.sessionStorage !== undefined) {
                            WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
                        }
                    }
                }

                let Redeembalance = this.state.win
                console.log("STATEMENT 5 ddddddd rrrr 111", Redeembalance)
                let bonusCash = this.state.extraCash + this.state.bon
                let pkbonusCash = this.state.pokerExtraCash + this.state.pokerPromo
                this.setState({ redeembalance: this.state.win, bonusCash: bonusCash.toFixed(2), pokerBonusCash: pkbonusCash.toFixed(2) })
                this.setState({ token: window.sessionStorage["token"], a23token: window.sessionStorage["a23token"], channelCheckForRedeem: window.sessionStorage["channelCheckForRedeem"] })

                // console.log("Neee yenkama >>>>>",this.state.mobile);
                window.sessionStorage["mobile"] = this.state.mobile
                window.sessionStorage["userid"] = this.state.userId;
                window.sessionStorage["kycStatus"] = this.state.kycStatus;
                // Uncomment bottom two brackets on push
            }
        }

        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_mywallet_pageview", eventProperties: {
                aceLevel: this.state.aceLevel,
                Acepoints_balance: this.state.acepointsbalance,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],
                winnings_balance: this.state.redeembalance,
                bonuscash_balance: this.state.bon,
                locked_bonus: this.state.lockedbonus,
                deposits_balance: this.state.deposits,
                wallet_balance: this.state.totalUserbalance,
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName,
                tdsRefundConfig: this.state.tdsRefundConfig,
                tdsRefundEligibility: this.state.tdsRefundEligibility,
                tdsRefundAmount: this.state.tdsRefundAmount,
                timestamp: new Date().getTime()
            }
        })


        WebToNativeMessage({
            type: "plotlineEvent", eventName: "PF_c_mywallet_pageview", eventProperties: {
                aceLevel: this.state.aceLevel,
                Acepoints_balance: this.state.acepointsbalance,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],
                winnings_balance: this.state.redeembalance,
                bonuscash_balance: this.state.bon,
                locked_bonus: this.state.lockedbonus,
                deposits_balance: this.state.deposits,
                wallet_balance: this.state.totalUserbalance,
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName,
                tdsRefundConfig: this.state.tdsRefundConfig,
                tdsRefundEligibility: this.state.tdsRefundEligibility,
                tdsRefundAmount: this.state.tdsRefundAmount,
                timestamp: new Date().getTime()
            }
        })


        WebToNativeMessage({
            type: "mixpanelEvent", eventName: "PF_c_mywallet_pageview", eventProperties: {
                aceLevel: this.state.aceLevel,
                Acepoints_balance: this.state.acepointsbalance,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],
                winnings_balance: this.state.redeembalance,
                bonuscash_balance: this.state.bon,
                locked_bonus: this.state.lockedbonus,
                deposits_balance: this.state.deposits,
                wallet_balance: this.state.totalUserbalance,
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName,
                tdsRefundConfig: this.state.tdsRefundConfig,
                tdsRefundEligibility: this.state.tdsRefundEligibility,
                tdsRefundAmount: this.state.tdsRefundAmount,
                timestamp: new Date().getTime()
            }
        })
    }

    getTDSInfo = async () => {
        if (this.state.pokerTotal > 0) {
            this.props.toggleModalAction(true, <Progress></Progress>)
            await this.props.getPokerAmountTDSInfo(this.state.token, "poker", this.state.pokerDeposit, "real", "NA", this.state.pokerTotal, this.state.pokerWin, this.state.screenName, this.state.pokerExtraCash, this.state.pokerPromo, this.state.userId, "INR");
            const { tdsInfoResponse } = this.props.userState;
            if (tdsInfoResponse.error) {
                this.props.toggleModalAction(false)
                this.setState({
                    errors: { message: tdsInfoResponse.error.message },
                })
            } else {
                this.props.toggleModalAction(false)
                this.setState({
                    pk_panStatus: tdsInfoResponse.panStatus,
                    pk_amount: tdsInfoResponse.amount,
                    pk_tdsAmount: tdsInfoResponse.tdsAmount,
                    pk_kycStatus: tdsInfoResponse.kycStatus,
                })
            }
            if (this.state.pk_tdsApplicable) {
                this.props.toggleModalAction(true, <PokertoA23Trasnfer isTdsApplicable={this.state.pk_tdsApplicable} amount={this.state.pk_amount} kycStatus={this.state.pk_kycStatus} tdsAmount={this.state.pk_tdsAmount} handleUserTDSInfoRes={() => this.updateUserBalance()}></PokertoA23Trasnfer>);
            }
        } else {
            this.props.toggleModalAction(true, <CommonAlert
                header={POKER_TDS_INFO.POKER_TDS_INFO_HEADER}
                body={POKER_TDS_INFO.POKER_INSUFFICIENT_BALANCE}
                btntext={POKER_TDS_INFO.POKER_COMMONALERT_CLOSE}
            ></CommonAlert>);
        }
    }

    calculateDaysLeft = (expiryDate) => {
        let difference = Math.ceil((expiryDate - Date.now()) / (1000 * 60 * 60 * 24))
        if ((difference < 0) || (difference > 5)) {
            return null
        } else {
            if (difference <= 1) {
                return 1
            } else {
                return difference
            }
        }
    }

    handleInfoIcon = () => {
        this.setState({ redeemInfoStatus: true })
        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_Click_mywallet_winningsmoreinfo", eventProperties: {
                aceLevel: this.state.aceLevel,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName
            }
        })
    }

    handleWinningsCT = () => {
        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_Click_mywallet_winningswithdraw", eventProperties: {
                aceLevel: this.state.aceLevel,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],//this.state.channel,
                wallet_balance: this.state.totalUserbalance,
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName
            }
        })
        WebToNativeMessage({
            type: "rstsData", rstsData: {
                eventData: {
                    player_id: this.state.screenName,
                    deposits_bucket_amt: this.props.userState && this.props.userState?.totalDeposits ? this.props.userState.totalDeposits : 0,
                    channel: window.sessionStorage["channel"],
                    winnings_amt: this.state.redeembalance,
                    ace_points_available: this.props.userState && this.props.userState?.currentTotalAcePoints ? this.props.userState.currentTotalAcePoints : 0,
                    acelevel: this.state.aceLevel,
                    wallet_balance: this.state.totalUserbalance,
                },
                isevent: "yes",
                tableName: "player_redeem_click"
            }
        })
    }

    checkForAdFlowEnabledStatus = () => {
        let isAdFlowEnabled = window.sessionStorage.getItem("withDrawClickAdFlowEnabled");

        if (isAdFlowEnabled) {
            WebToNativeMessage({
                type: "playWithDrawInterstitialAd"
            })
        } else {
            this.props.history.push({
                pathname: "/redeem/",
                token: window.sessionStorage["token"],
                from: "wallet"
            });
        }
    }

    handleAcePointsRedirection = () => {
        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_Click_mywallet_acepointsmoreinfo", eventProperties: {
                aceLevel: this.state.aceLevel,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],//this.state.channel,
                wallet_balance: this.state.totalUserbalance,
                winnings_balance: this.state.redeembalance,
                username: this.state.screenName
            }
        })
        this.props.history.push('/loyalty/')
    }

    handleAcePointsChange = (value) => {
        const { redeemAcePointsDetails } = this.props.userState
        let insufficientBalance = false
        let isLimitExceeded = false
        // let reminderValue = Number(event.target.value) % 100
        insufficientBalance = Number(value) > redeemAcePointsDetails.currentTotalAcePoints
        if (!insufficientBalance) {
            isLimitExceeded = Number(value) > redeemAcePointsDetails.redeemLimit - redeemAcePointsDetails.acePointsRedeemedInCurrentLevel
        }

        if (!isNaN(value)) {
            this.setState({
                acePointsToConvert: value,
                // showAcePointsValueMultiplesError: reminderValue !== 0,
                showAcePointsValueMultiplesError: false,
                showAcePointsLimitExceeded: isLimitExceeded,
                showInsufficientAcePoints: insufficientBalance,
                // enableAcePointsClaimButton: !isLimitExceeded && reminderValue === 0 && Number(event.target.value) > 0 && !insufficientBalance
                enableAcePointsClaimButton: !isLimitExceeded && Number(value) >= redeemAcePointsDetails.minRedeemableValue && !insufficientBalance

            })
        } else {
            return
        }
    }

    acepointsIcon =
        <img className="info-icon ml3" src={InfoIcon} onClick={() => {
            this.setState({
                openRedeemAcepointsInfoPopUp: true
            })
        }} />

    // handleAcePointsErrorMessage = (val) => {
    //     const { redeemAcePointsDetails } = this.props.userState
    //     if(isNaN(val) && val!==''){
    //         return ''
    //     }

    //     if ((!(redeemAcePointsDetails.currentTotalAcePoints === null || redeemAcePointsDetails.currentTotalAcePoints === undefined) && (redeemAcePointsDetails.currentTotalAcePoints === 0 || redeemAcePointsDetails.currentTotalAcePoints < redeemAcePointsDetails.minRedeemableValue || redeemAcePointsDetails.minRedeemableValue < redeemAcePointsDetails.redeemLimits[redeemAcePointsDetails.currentAceLevelName].min)) || val==='') {
    //         return <span className={"redeem-ace-points-exceed-limit-text"}>Your redeemable AcePoints balance should be more than 10 {this.acepointsIcon}</span>
    //     }
    //     else if (redeemAcePointsDetails.currentTotalAcePoints < redeemAcePointsDetails.minRedeemableValue) {
    //         return <span className="redeem-ace-points-exceed-limit-text" >Your redeemable AcePoints balance should be more than {redeemAcePointsDetails.minRedeemableValue} {this.acepointsIcon}</span>
    //     }
    //     else if (redeemAcePointsDetails.currentTotalAcePoints >= redeemAcePointsDetails.redeemLimit) {
    //         if (redeemAcePointsDetails.maxRedeemableValue === redeemAcePointsDetails.redeemLimit || (redeemAcePointsDetails.maxRedeemableValue >= redeemAcePointsDetails.minRedeemableValue && redeemAcePointsDetails.maxRedeemableValue < redeemAcePointsDetails.redeemLimit)) {
    //             if (val < redeemAcePointsDetails.minRedeemableValue || val > redeemAcePointsDetails.maxRedeemableValue) {
    //                 return <span className="redeem-ace-points-exceed-limit-text">Please enter AcePoints between {redeemAcePointsDetails.minRedeemableValue} to {redeemAcePointsDetails.maxRedeemableValue} {this.acepointsIcon}</span>
    //             }
    //             else if (val >= redeemAcePointsDetails.minRedeemableValue && val <= redeemAcePointsDetails.maxRedeemableValue) {
    //                 return <span className="redeem-ace-points-note-text">*Note : You can redeem upto {redeemAcePointsDetails.maxRedeemableValue} AcePoints this month {this.acepointsIcon}</span>
    //             }
    //         }
    //     }
    //     else if (redeemAcePointsDetails.currentTotalAcePoints >= redeemAcePointsDetails.minRedeemableValue && redeemAcePointsDetails.currentTotalAcePoints < redeemAcePointsDetails.redeemLimit) {
    //         if (redeemAcePointsDetails.currentTotalAcePoints === redeemAcePointsDetails.maxRedeemableValue) {
    //             if (val < redeemAcePointsDetails.minRedeemableValue || val > redeemAcePointsDetails.maxRedeemableValue) {
    //                 return <span className="redeem-ace-points-exceed-limit-text">Please enter AcePoints between {redeemAcePointsDetails.minRedeemableValue} to {redeemAcePointsDetails.maxRedeemableValue} {this.acepointsIcon}</span>
    //             }
    //             else if (val >= redeemAcePointsDetails.minRedeemableValue && val <= redeemAcePointsDetails.maxRedeemableValue) {
    //                 return <span className="redeem-ace-points-note-text">*Note : You can redeem upto {redeemAcePointsDetails.maxRedeemableValue} AcePoints this month {this.acepointsIcon}</span>
    //             }
    //         }
    //         else if (redeemAcePointsDetails.maxRedeemableValue >= redeemAcePointsDetails.minRedeemableValue && redeemAcePointsDetails.maxRedeemableValue < redeemAcePointsDetails.currentTotalAcePoints) {
    //             if (val < redeemAcePointsDetails.minRedeemableValue || val > redeemAcePointsDetails.currentTotalAcePoints) {
    //                 return <span className="redeem-ace-points-exceed-limit-text">Please enter AcePoints between {redeemAcePointsDetails.minRedeemableValue} to {redeemAcePointsDetails.maxRedeemableValue} {this.acepointsIcon}</span>
    //             }
    //             else if (val >= redeemAcePointsDetails.minRedeemableValue && val < redeemAcePointsDetails.currentTotalAcePoints) {
    //                 return <span className="redeem-ace-points-note-text">*Note : You can redeem upto {redeemAcePointsDetails.maxRedeemableValue} AcePoints this month {this.acepointsIcon}</span>
    //             }
    //         }
    //         else if (redeemAcePointsDetails.maxRedeemableValue < redeemAcePointsDetails.minRedeemableValue) {
    //             return <span className="redeem-ace-points-exceed-limit-text">Your redeemable AcePoints balance should be more than {redeemAcePointsDetails.minRedeemableValue} {this.acepointsIcon}</span>
    //         }
    //     }
    //     else {
    //         return ''
    //     }

    // }

    handleAcePointsErrorMessage = (val) => {
        const { redeemAcePointsDetails } = this.props.userState
        const totalAcepoints = redeemAcePointsDetails.currentTotalAcePoints;
        const maxRedeemableValue = redeemAcePointsDetails.maxRedeemableValue;
        const minRedeemableValue = redeemAcePointsDetails.minRedeemableValue;
        // const minLimitOfAceLevel = redeemAcePointsDetails.redeemLimits[redeemAcePointsDetails.currentAceLevelName].min
        // const maxLimitOfAceLevel = redeemAcePointsDetails.redeemLimits[redeemAcePointsDetails.currentAceLevelName].max
        const redeemLimitOfMonth = redeemAcePointsDetails.redeemLimit
        console.log(val)
        if (!isNaN(val) && val !== '') {
            if (totalAcepoints < minRedeemableValue || maxRedeemableValue < minRedeemableValue) {
                return <span className={"redeem-ace-points-exceed-limit-text"}>Your redeemable {!this.state.isOem ? "AcePoints" : "BlackPoints"} balance should be more than {minRedeemableValue} {!this.state.isOem ? this.acepointsIcon : ""}</span>
            }

            else if ((totalAcepoints >= redeemLimitOfMonth) || (totalAcepoints >= minRedeemableValue && totalAcepoints < redeemLimitOfMonth)) {
                if (Number(val) < minRedeemableValue || Number(val) > maxRedeemableValue || Number(val) > totalAcepoints) {
                    return <span className="redeem-ace-points-exceed-limit-text">Please enter {!this.state.isOem ? "AcePoints" : "BlackPoints"} between {minRedeemableValue} to {maxRedeemableValue > totalAcepoints ? totalAcepoints : maxRedeemableValue} {!this.state.isOem ? this.acepointsIcon : ""}</span>
                }
                else if (Number(val) >= minRedeemableValue && Number(val) <= maxRedeemableValue) {
                    return <span className="redeem-ace-points-note-text">*Note : You can withdraw upto {maxRedeemableValue} {!this.state.isOem ? "AcePoints" : "BlackPoints"} this month {!this.state.isOem ? this.acepointsIcon : ""}</span>
                }
            }
        }
        else {
            if (val === '') {
                if (totalAcepoints < minRedeemableValue) {
                    return <span className={"redeem-ace-points-exceed-limit-text"}>Your withdrawable {!this.state.isOem ? "AcePoints" : "BlackPoints"} balance should be more than {minRedeemableValue} {!this.state.isOem ? this.acepointsIcon : ""}</span>
                }
                return ''
            }
            return ''
        }
        return ''
    }


    handleAcePointsFocusChange = () => {
        const containerWithKeyboardOpen = document.getElementsByClassName('redeem-ace-level-modal-open-keyboard-open')

        if (this.isAndroid()) {
            this.setState({
                redeemAcePointsKeyboardOpen: true
            })
        }
        try {
            setTimeout(() => {
                if (containerWithKeyboardOpen && containerWithKeyboardOpen.length > 0) {
                    if (containerWithKeyboardOpen?.[0].offsetTop <= 0) { //Checking ace points redeem modal should not be in negative offset from screen.
                        containerWithKeyboardOpen[0].style.bottom = "10px" // if modal goes in negative we are making it to be default bottom to 0px.                   
                    }
                }
            }, 200)
        } catch (e) { }

    }

    handleAcePointsBlurChange = () => {
        if (this.isAndroid()) {
            const inputFieldElement = document.getElementsByClassName('redeem-ace-points-input')
            if (inputFieldElement && inputFieldElement.length > 0) {
                inputFieldElement[0].blur()
            }
            this.setState({
                redeemAcePointsKeyboardOpen: false
            })
        }

    }

    handleAcePointsClaim = async () => {
        this.setState({
            enableAcePointsClaimButton: false
        })
        const requestBody = {
            acePointsToRedeem: Number(this.state.acePointsToConvert)
        }
        const claimPromise = await this.props.submitClaimRedeemAcePoints(this.state.token, requestBody)
        this.setState({
            showRedeemAceLevelModal: false,
            showAcePointsRedeemSuccessModal: true,
            acePointsToConvert: ""
        })
        this.getRedeemAcePointsDetails()


    }

    getLastXdaysText = (x) => {
        let d = new Date()
        let t = new Date(d.getTime() - ((x - 1) * 86400000))
        if (x <= 1) {
            var time =
                '(' + d.getDate() + "/" + `${d.getMonth() + 1}` + "/" + d.getFullYear() + ')'
        }
        else {
            var time =
                '(' + t.getDate() + "/" + `${t.getMonth() + 1}` + "/" + t.getFullYear() + " to " + d.getDate() + "/" + `${d.getMonth() + 1}` + "/" + d.getFullYear() + ')'
        }

        return time;

    }

    getAcePointsConversionAmount = (redeemAcePointsDetails) => {
        if (this.state.acePointsToConvert.length === 0 || Number(redeemAcePointsDetails?.currentTotalAcePoints) < 1) {
            return '-'
        } else {
            const { convertCashValue, convertAcePts } = redeemAcePointsDetails
            const conversionValue = (Number(this.state.acePointsToConvert) * convertCashValue / convertAcePts)
            return `₹${conversionValue || 0}`
        }
    }

    handleBackBtnClick = async (msg) => {
        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_mywallet_clickback", eventProperties: {
                aceLevel: this.state.aceLevel,
                userID: this.state.userId,
                subscriptionType: this.state.subscriptionType,
                channel: window.sessionStorage["channel"],//this.state.channel,
                wallet_balance: this.state.totalUserbalance,
                username: this.state.screenName
            }
        })
        WebToNativeMessage(msg)
    }

    handleOutSideClick = () => {
        const handleOutSideClick = new Event('handleOutSideClick');
        dispatchEvent(handleOutSideClick);
    }
    render() {
        const assetChanges = this.context;

        console.log(assetChanges, " assetChanges in walletinfo");
        const { redeemAcePointsDetails } = this.props.userState
        return (
            // Parent Div for entire wallet
            <div id="walletInfoContainer1" style={{ width: "100%", height: "100%", overflow: 'hidden' }}>
                {/* TDS Iframe */}
                {this.state.showIframe && <div
                    //  style={{ position: "absolute", width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: '99999' }}
                    className="tdsIframeDiv">
                    <div
                        // style={{ position: 'absolute', width: '100%', height: '100%', background: "rgba(0,0,0,0.5)" }} onClick={() => this.setState({ showIframe: false })}
                        className="tdsIframeSubDiv"></div>
                    <div
                        // style={{ display: "flex", flexDirection: 'column', position: "absolute", width: "95%", height: "75%", justifyContent: "center", alignItems: "center", overflow: "hidden", backgroundColor: 'white' }}
                        className="tdsIframeSubDiv1">
                        <div
                            // style={{ width: "100%", background: "#032146", color: "#FFFFFF", height: "7%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', fontWeight: '700' }}
                            className="tdsIframeSubDivImgDiv">TDS
                            <img src={!this.state.isOem ? Cross : oemCross} alt='close' style={{ position: "absolute", right: "5%" }} onClick={() => this.setState({ showIframe: false })} />
                        </div>
                        <div style={{ width: '100%', height: '93%' }}>
                            <iframe style={{ paddingTop: "", marginTop: "", marginBottom: "", height: "100%", width: "100%", overflow: "scroll" }} height="100%" width="100%" title="" overflowy="scroll" src={createOEMAdminPageURL(process.env.REACT_APP_REAL_STATIC_WEB_URL, process.env.REACT_APP_OEMWEB_BASE_URL, "tds.html?src=mapp&header=N&t=" + Math.random(), this.state.isOem)}>
                            </iframe>
                        </div>
                    </div>

                </div>}
                {/* End of TDS Iframe */}
                {/* TDS Slider */}
                <div className="TDSPopup"
                    style={{ display: this.state.showTaxPopup ? "flex" : "none" }}
                    onClick={
                        () => {
                            // alert()
                            // this.setState({
                            //     showTaxPopup: false
                            // })
                        }
                    }>
                    <div style={{ width: "100%", height: "100%", position: "absolute", backgroundColor: "", top: "0px", zIndex: "4", borderTopLeftRadius: "9px", borderTopRightRadius: "9px", maxWidth: "600px" }} onClick={
                        () => {
                            // alert()
                            this.setState({
                                showTaxPopup: false
                            })
                        }
                    }>

                    </div>
                    <div className="animateDiv"
                        //  style={{ width: "98%", height: "60%", position: "absolute", backgroundColor: "#ffffff", bottom: "-50%", zIndex: "5", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", maxWidth: "600px" }} 
                        onClick={
                            (e) => {
                                console.log("Pointer events", e);
                                // alert();
                                e.stopPropagation();
                            }
                        }>

                        <img id="wt_closeicon"
                            src={!this.state.isOem ? NewClose : oemCross}
                            className=""
                            style={{ width: "14px", height: "14px", position: "absolute", top: "16px", right: "10px", zIndex: "55" }}
                            onClick={
                                () => {
                                    // alert()
                                    this.setState({
                                        showTaxPopup: false
                                    })
                                }
                            }
                        // onClick={() => this.handleBackBtnClick({ type: "closeClient" })}
                        />

                        {/* <div id="header"
                            className="headerClass">
                            <span id="wt_taxablenetwinnings_header"
                                className="headerClass1">{this.state.showRedeemableBalanceInWalletInfo ? 'Taxable Withdrawals' : 'Taxable Net Winnings'}</span>
                        </div> */}




                        <div style={{ width: "95%", marginLeft: "2.5%", marginRight: "2.5%", height: "10%", display: "flex", backgroundColor: "", position: "", bottom: "", justifyContent: "center", alignItems: "center" }}>

                            <div style={{ display: "flex", textAlign: "start", justifyContent: "flex-start", alignItems: "", width: "65%" }}>
                                <span className='standardTextMedium' style={{ fontSize: "11px" }}>Calculated from  <span className='standardTextMedium' style={{ fontSize: "11px", fontWeight: "800", paddingLeft: "4px" }}>{this.state.currentFinYear}</span></span>
                                {/* <span className='standardTextMedium' style={{ fontSize: "14px", fontWeight: "800", paddingLeft: "4px" }}>{profileData?.currentFinYear}</span> */}
                            </div>

                            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", textAlign: "start", marginLeft: "10px", width: "35%", height: "25%", backgroundColor: "" }}>
                                <span id="wt_knowmore_about_tds" className="smt"
                                    // style={{ width: 'fit-content', fontSize: "12px", color: "#196a29", textDecoration: "underline" }} 
                                    onClick={() => {
                                        // setShowTaxPopUp(false)
                                        // setShowIframe(true);
                                        this.setState({ showIframe: true })
                                        // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_TDS_ViewPolicyPopUp", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Placement Page' } })
                                        WebToNativeMessage({ type: "redeemCTEvent", eventName: "pf_c_know_more_about_tds_netTaxableWinnings", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], winnings: this.state.taxableRunningNetWin, walletbalance: this.state.userBalance } })


                                    }}>Know More About TDS </span>
                            </div>
                            {/* <div id="wt_calculatedfrom_text" style={{ display:"flex", textAlign: "start",justifyContent:"flex-start",alignItems:""}}> */}
                            {/* <span className="smt2">Calculated from <span className="smt1" style={{fontSize:"11px",fontWeight: "800", paddingLeft: "4px"}}> {this.state.currentFinYear}</span> </span> */}
                            {/* <span className="smt1"> {this.state.currentFinYear}</span> */}
                            {/* </div> */}


                            {/* <div style={{ width: "100%", height: "50%", display: "flex", flexDirection: "column", justifyContent: "flex-end", textAlign: "start" }}>

                                <span id="wt_knowmore_about_tds" className="smt"
                                    // style={{ width: 'fit-content', fontSize: "12px", color: "#196a29", textDecoration: "underline" }} 
                                    onClick={() => {
                                        // setShowTaxPopUp(false)
                                        // setShowIframe(true);
                                        this.setState({ showIframe: true })
                                        // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_TDS_ViewPolicyPopUp", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Placement Page' } })
                                        WebToNativeMessage({ type: "redeemCTEvent", eventName: "pf_c_know_more_about_tds_netTaxableWinnings", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], winnings: this.state.taxableRunningNetWin, walletbalance: this.state.userBalance } })


                                    }}>Know More About TDS </span>
                            </div> */}
                        </div>



                        <div style={{ backgroundColor: "", width: "100%", height: "80%", display: "flex", justifyContent: "", alignItems: "center", position: "", top: "7%", flexDirection: "column" }}>
                            <div
                                //  style={{ width: "94%", height: "70%", borderRadius: "8px", position: "absolute", border: "1.5px solid #bababa", left: "3%", right: "3%", top: "", display: "flex", flexDirection: "column" }}
                                className="tds1">
                                <div
                                    className="tds2">
                                    {/* <div style={{ width: "100%", height: "65%", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                                        <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                                            <span id="wt_taxablenetwinnings_option"
                                                className="tdsSpan">{this.state.showRedeemableBalanceInWalletInfo ? 'Taxable Withdraw Amount' : 'Taxable Net Winnings'}
                                            </span>
                                        </div>

                                        <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", justifyContent: "flex-end" }}>
                                            <span id="wt_taxablenetwinnings_value"
                                                className="tdsSpan1">  &#8377;
                                                {Number(this.state.taxableRunningNetWin).toFixed(2)}</span>

                                        </div>

                                    </div> */}
                                    <div style={{ width: "100%", height: "35%", backgroundColor: "", display: "flex" }}>
                                        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                                            <span id="wt_taxablenetwinnings_info_static_text"
                                                className="tdsSpan2" >Total Withdrawals<span className="tdsSpan3">*</span> - {this.state.showRedeemableBalanceInWalletInfo ? 'TDS Paid Withdrawed Amount' : 'TDS Paid Net Winnings'}</span>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    // style={{ width: "100%", height: "30%", marginTop: "1%", paddingBottom: '1%', borderBottom: "1.5px solid #bababa" }}
                                    className="tdsSpanDiv" >
                                    <div style={{ width: "100%", height: "65%", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                                        <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                                            <span id="wt_tdsnetwinnings_options"
                                                //  style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}
                                                className="tdsSpanDiv1">{this.state.showRedeemableBalanceInWalletInfo ? 'TDS Paid Withdrawed Amount' : 'TDS Paid Net Winnings'}</span>
                                        </div>

                                        <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", justifyContent: "flex-end" }}>
                                            <span id="wt_tdsnetwinnings_value"
                                                //  style={{ fontSize: "18px", color: "#032146", paddingLeft: "16px", fontWeight: "bold" }}
                                                className="tdsSpanDiv2">  &#8377;
                                                {Number(this.state.tdsPaidNetWinning).toFixed(2)}</span>
                                            {/* taxedNetWinning */}

                                        </div>

                                    </div>
                                    <div style={{ width: "100%", height: "35%", backgroundColor: "", display: "flex" }}>
                                        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                                            <span id="wt_tdsnetwinnings_info_static_text"
                                                // style={{ fontSize: "10px", color: "#032146", paddingLeft: "16px", marginTop: "1%", marginBottom: "5%" }}
                                                className="tdsSpanDiv3">{this.state.showRedeemableBalanceInWalletInfo ? 'Withdrawed Amount' : 'Winnings'} on which TDS was paid</span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%", height: "33%", borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px", marginTop: "0%", marginBottom: '1%' }}>
                                    <div style={{ width: "100%", height: "65%", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                                        <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                                            <span id="wt_opening_balance"
                                                //  style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}
                                                className="tdsSpanDiv1" >{`Opening Balance (${this.state.fyYearString})`}</span>
                                        </div>

                                        <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", justifyContent: "flex-end" }}>
                                            <span id="wt_opening_balance_value"
                                                // style={{ fontSize: "18px", color: "#032146", paddingLeft: "16px", fontWeight: "bold" }}
                                                className="tdsSpanDiv2"
                                            >  &#8377;
                                                {Number(this.state.openingBalanceFinYear).toFixed(2)}</span>
                                            {/* taxedNetWinning */}

                                        </div>

                                    </div>
                                    <div style={{ width: "100%", height: "35%", backgroundColor: "", display: "flex" }}>
                                        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                                            <span id="wt_opening_balance_info_static_text"
                                                // style={{ fontSize: "10px", color: "#032146", paddingLeft: "16px", marginTop: "1%", marginBottom: "5%" }}
                                                className="tdsSpanDiv3"
                                            >Opening balance for the current year</span>
                                        </div>
                                    </div>
                                </div>






                            </div>


                            {/* {!this.state.showRedeemableBalanceInWalletInfo && <div style={{ width: "100%", height: "10%", fontSize: '0.75rem', display: "flex", alignItems: "center", position: "", bottom: "", justifyContent: "flex-start", marginLeft: "5%", fontWeight: "bold" }}>
                                <span className="sm1" style={{}}><span className="sm2" style={{}}>*</span> Total Deposits - <span style={{ fontWeight: '400' }}>Deposits in FY + Opening Balance of FY</span></span>
                            </div>} */}



                            <div
                                //  style={{ width: "100%", height: "16%", borderTop: "1px solid #bababa", backgroundColor: "", position: "absolute", bottom: "0px", paddingTop: "10px" }}
                                className="btmTdsMainDiv" style={{ marginTop: "5px" }}>
                                <div style={{ width: "100%", height: "auto", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                                    <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                                        <span id="wt_total_tds_paid" className="tdsSpanDiv1"
                                        // style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}
                                        > Total TDS Paid</span>
                                    </div>

                                    <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", paddingTop: "0.8rem", justifyContent: "flex-end" }}>
                                        <span id="wt_total_tds_paid_value"
                                            // style={{ fontSize: "18px", color: "#032146", paddingLeft: "16px", fontWeight: "bold" }}
                                            className="btmTdsDiv1"
                                        >  &#8377;
                                            {Number(this.state.totalTaxPaid).toFixed(2)}</span>
                                    </div>
                                </div>
                                <div style={{ width: "100%", height: "auto", backgroundColor: "", display: "flex" }}>
                                    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                                        <span id="wt_total_tds_paid_info_static_text"
                                            //  style={{ fontSize: "12px", color: "#032146", paddingLeft: "16px" }}
                                            className="btmTdsDiv">30% of TDS paid on {this.state.showRedeemableBalanceInWalletInfo ? 'Withdraw Amount' : 'Withdraw Amount'}</span>
                                    </div>
                                </div>
                            </div>


                            {(((sessionStorage.getItem("tdsHistoryPageAvailable") && sessionStorage.getItem("tdsHistoryPageAvailable") === "true")) || this.state.tdsRefundUrl !== "") && <div className="btmTdsMainDiv" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>

                                {<div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "", justifyContent: "center" }}>
                                    <span id="wt_total_tds_paid" className="tdsSpanDiv1"
                                    // style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}
                                    > Download Reports ( <span>{this.state.downloadfinancialYear} </span> )</span>

                                    <div style={{ width: "100%", height: "50%", display: "flex", justifyContent: "", alignItems: "center" }}>
                                        {((sessionStorage.getItem("tdsHistoryPageAvailable") && sessionStorage.getItem("tdsHistoryPageAvailable") === "true")) && <div style={{ height: "100%", display: "flex", alignItems: "center", paddingLeft: "5%" }}>
                                            <span className="smt" onClick={() => {
                                                //openTDSHistoryPage
                                                WebToNativeMessage({ type: 'openTDSHistoryPage' });
                                                WebToNativeMessage({
                                                    type: "redeemCTEvent", eventName: "PF_DownloadTDS_click", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })

                                                WebToNativeMessage({
                                                    type: "plotlineEvent", eventName: "PF_DownloadTDS_click", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })

                                                WebToNativeMessage({
                                                    type: "mixpanelEvent", eventName: "PF_DownloadTDS_click", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })
                                            }} >{this.state.tdshistoryReportHyperlinkName}</span>
                                        </div>}

                                        {(this.state.tdsRefundUrl !== "") && <div style={{ marginLeft: "5%", height: "100%", display: "flex", alignItems: "center", paddingLeft: "" }}>




                                            <div >
                                                <span className="smt" onClick={() => {
                                                    WebToNativeMessage({ downloadUrl: this.state.tdsRefundUrl })


                                                    WebToNativeMessage({
                                                        type: "redeemCTEvent", eventName: "PF_annualsummary_click", eventProperties: {
                                                            Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                            bonuscash_balance: this.state.bon,
                                                            locked_bonus: this.state.lockedbonus,
                                                            deposits_balance: this.state.deposits,
                                                            wallet_balance: this.state.totalUserbalance,
                                                            winnings_balance: this.state.redeembalance,
                                                            username: this.state.screenName,
                                                            tdsRefundConfig: this.state.tdsRefundConfig,
                                                            tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                            tdsRefundAmount: this.state.tdsRefundAmount,
                                                            timestamp: new Date().getTime()
                                                        }
                                                    })

                                                    WebToNativeMessage({
                                                        type: "plotlineEvent", eventName: "PF_annualsummary_click", eventProperties: {
                                                            Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                            bonuscash_balance: this.state.bon,
                                                            locked_bonus: this.state.lockedbonus,
                                                            deposits_balance: this.state.deposits,
                                                            wallet_balance: this.state.totalUserbalance,
                                                            winnings_balance: this.state.redeembalance,
                                                            username: this.state.screenName,
                                                            tdsRefundConfig: this.state.tdsRefundConfig,
                                                            tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                            tdsRefundAmount: this.state.tdsRefundAmount,
                                                            timestamp: new Date().getTime()
                                                        }
                                                    })

                                                    WebToNativeMessage({
                                                        type: "mixpanelEvent", eventName: "PF_annualsummary_click", eventProperties: {
                                                            Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                            bonuscash_balance: this.state.bon,
                                                            locked_bonus: this.state.lockedbonus,
                                                            deposits_balance: this.state.deposits,
                                                            wallet_balance: this.state.totalUserbalance,
                                                            winnings_balance: this.state.redeembalance,
                                                            username: this.state.screenName,
                                                            tdsRefundConfig: this.state.tdsRefundConfig,
                                                            tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                            tdsRefundAmount: this.state.tdsRefundAmount,
                                                            timestamp: new Date().getTime()
                                                        }
                                                    })
                                                }}>{this.state.itrReportHyperlinkName}</span>
                                            </div>
                                        </div>}
                                    </div>


                                </div>}




                            </div>}




                            {/* {!this.state.showRedeemableBalanceInWalletInfo && <div style={{ width: "100%", height: "15%", fontSize: '0.75rem', display: "flex", alignItems: "center", position: "absolute", bottom: "-31%", justifyContent: "flex-end", paddingRight: "16px", fontWeight: "bold" }}>
                                <span className="sm1" style={{}}><span className="sm2" style={{}}>*</span> Total Deposits - <span style={{ fontWeight: '400' }}>Deposits in FY + Opening Balance of FY</span></span>
                            </div>} */}



                        </div>

                        {/* <div
                            //  style={{ width: "100%", height: "16%", borderTop: "1px solid #bababa", backgroundColor: "", position: "absolute", bottom: "0px", paddingTop: "10px" }}
                            className="btmTdsMainDiv">
                            <div style={{ width: "100%", height: "auto", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                                <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                                    <span id="wt_total_tds_paid" className="tdsSpanDiv1"
                                    // style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}
                                    > Total TDS Paid</span>
                                </div>

                                <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", paddingTop: "0.8rem", justifyContent: "flex-end" }}>
                                    <span id="wt_total_tds_paid_value"
                                        // style={{ fontSize: "18px", color: "#032146", paddingLeft: "16px", fontWeight: "bold" }}
                                        className="btmTdsDiv1"
                                    >  &#8377;
                                        {Number(this.state.totalTaxPaid).toFixed(2)}</span>
                                </div>
                            </div>
                            <div style={{ width: "100%", height: "auto", backgroundColor: "", display: "flex" }}>
                                <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                                    <span id="wt_total_tds_paid_info_static_text"
                                        //  style={{ fontSize: "12px", color: "#032146", paddingLeft: "16px" }}
                                        className="btmTdsDiv">30% of TDS paid on {this.state.showRedeemableBalanceInWalletInfo ? 'Redeem Amount' : 'Winnings'}</span>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                {/* End of TDS Slider */}

                {/* Redeemable Amount Pop Up */}

                {this.state.showRedeemableBalancePopUp && <div
                    //  style={{ width: "100%", height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', backgroundColor: "rgba(0,0,0,0.5)", zIndex: "5" }}
                    className="id10">
                    <div style={{ position: "absolute", width: '100%', height: '100%', zIndex: '3' }} onClick={() => (this.setState({ showRedeemableBalancePopUp: false, showBonusDetailsInRedeemPopUp: false }))} ></div>
                    <div style={{ width: "98%", height: "65%", maxWidth: "570px", display: 'flex', flexDirection: 'column', borderRadius: "5px", zIndex: '5' }}>
                        <div
                            // style={{ width: '100%', height: '10%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#2C5391', borderRadius: '5px 5px 0px 0px' }}
                            className="id9">
                            <span
                                //  style={{ fontWeight: "700", fontSize: '1.1rem', color: '#FFFFFF' }}
                                className="id8">Withdrawable Amount</span>
                            <span style={{ position: "absolute", width: '100%', maxWidth: '570px', display: 'flex', alignItems: 'center' }}>
                                <img src={!this.state.isOem ? Cross : oemCross} onClick={() => (this.setState({ showRedeemableBalancePopUp: false, showBonusDetailsInRedeemPopUp: false }))} style={{ position: "absolute", maxWidth: "570px", right: "4%", zIndex: "100" }}></img>
                            </span>
                        </div>
                        <div
                            //  style={{ width: '100%', maxHeight: "90%", overflowY: "scroll", display: 'flex', alignItems: "center", justifyContent: 'center', background: "#FFFFFF", borderRadius: '0px 0px 5px 5px' }}

                            className="id7">
                            <div style={{ position: "absolute", width: '100%', height: '100%', zIndex: '4', display: `${this.state.showBonusDetailsInRedeemPopUp ? 'none' : ''}` }} onClick={() => (this.setState({ showRedeemableBalancePopUp: false, showBonusDetailsInRedeemPopUp: false }))} ></div>

                            <div style={{ width: '95%', margin: 'auto', padding: "20px 0px", zIndex: "5" }}>
                                <div style={{ fontSize: '0.65rem', fontWeight: "700", width: "100%", display: 'flex', alignItems: 'center', justifyContent: "flex-end", marginBottom: "10px" }}><span
                                    // style={{ borderBottom: "1px solid #032146", color: '#032146', paddingBottom: "2px" }} 
                                    className="id6" onClick={() => WebToNativeMessage({ type: 'openRedeemPolicy' })}> View Withdraw Policy</span></div>
                                <div
                                    // style={{ border: '1px solid #bababa', borderRadius: '5px' }}
                                    className="id5">
                                    <div
                                        // style={{ width: "100%", background: '#58B6C640', padding: "20px 0px", color: '#032146', borderBottom: '1px solid #bababa' }}
                                        className="id4">
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '95%', margin: 'auto', fontWeight: "700" }}>
                                            <span className="standardText" style={{ width: "50%", textAlign: 'left', fontSize: "1rem" }}>Withdrawable Amount</span>
                                            <span className="standardTextDark" style={{ width: "50%", textAlign: 'right', fontSize: "1.15rem" }}>&#8377;{this.state.redeemableAmount.toFixed(2)}</span>
                                        </div>
                                        <div className="standardTextLight" style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', width: '95%', margin: 'auto', marginTop: '5px', fontSize: '0.9rem' }}>Winnings - Bonus given in Last {this.state.bonusReleasedLastXDays} {this.state.bonusReleasedLastXDays > 1 ? 'days' : 'day'}</div>
                                    </div>
                                    <div style={{ width: '100%', padding: '20px 0px' }}>
                                        <div
                                            // style={{ width: "95%", color: "#032146", margin: "auto", borderBottom: '0.5px solid #bababa', paddingBottom: "20px", display: 'flex', alignItems: 'center', justifyContent: "space-between" }}
                                            className="id2">
                                            <span className="standardText" style={{ fontSize: "0.9rem", fontWeight: "700" }} >Winnings</span>
                                            <span className="standardTextDark" style={{ fontSize: "1.1rem", fontWeight: "700" }}>&#8377;{this.state.win.toFixed(2)}</span>
                                        </div>
                                        <div style={{ width: "95%", margin: 'auto', paddingTop: "20px" }}>
                                            <div
                                                //  style={{ width: "100%", color: "#032146", margin: "auto", display: 'flex', alignItems: 'center', justifyContent: "space-between" }}
                                                className="id3">
                                                <span className="standardText" style={{ fontSize: "0.9rem", fontWeight: "700" }} >Bonus</span>
                                                <span
                                                    //  style={{ fontSize: "1.1rem", fontWeight: "700", color: '#032146' }}
                                                    className="id1">{this.state.bonusReleasedLastXDaysAmt > 0 ? '-' : ''} &#8377;{this.state.bonusReleasedLastXDaysAmt.toFixed(2)}</span>
                                            </div>
                                            <span className="standardTextLight" style={{ fontSize: '0.9rem' }}>Credited in Last {this.state.bonusReleasedLastXDays} {this.state.bonusReleasedLastXDays > 1 ? 'days' : 'day'} {this.getLastXdaysText(this.state.bonusReleasedLastXDays)}</span>
                                            {this.state.bonusReleasedLastXDaysList.length > 0 && <div style={{ width: '100%', marginTop: '5px' }}>
                                                <div style={{ width: '100%' }}>
                                                    <span
                                                        // style={{ fontSize: '0.8rem', fontWeight: "700", paddingBottom: "2px", borderBottom: "1px solid #032146" }}
                                                        className="bonReleasedLastXdays"
                                                        onClick={() => this.setState({ showBonusDetailsInRedeemPopUp: !this.state.showBonusDetailsInRedeemPopUp })}
                                                    >{this.state.showBonusDetailsInRedeemPopUp ? <>See Less <img style={{

                                                        width: "12px",
                                                        marginLeft: "1%",
                                                    }} src={!this.state.isOem ? upArrow : oemupArrow} /></> : <>See More <img style={{ width: "12px" }} src={!this.state.isOem ? downArrow : oemdownArrow} /></>}</span>
                                                </div>
                                                {this.state.showBonusDetailsInRedeemPopUp && <div
                                                    // style={{ width: '100%', marginTop: '10px', border: "1px solid #bababa", borderRadius: "5px", display: "flex", flexDirection: "column" }}
                                                    className="bonusDetailsInRedeemPopUp">
                                                    <div
                                                        // style={{ width: "100%", height: "35px", display: 'flex', fontSize: "0.9rem", fontWeight: "700", color: "#032146", flexDirection: 'row', alignItems: 'center', justifyContent: "space-evenly", background: "#4A75BC40", borderRadius: "5px 5px 0px 0px" }}
                                                        className="bonusCodeName1">
                                                        <div style={{ width: "30%", textAlign: "left" }}>Bonus Type</div>
                                                        <div style={{ width: "30%", textAlign: "center" }}>Amount</div>
                                                        <div style={{ width: "30%", textAlign: "right" }}>Date &amp; Time</div>
                                                    </div>
                                                    <div className={this.state.bonusReleasedLastXDaysList.length > 3 ? "bonusScrollView" : ""} style={{ width: "100%", minheight: "35px", maxHeight: "105px", display: "flex", flexDirection: "column", overflowY: 'scroll' }}>
                                                        {this.state.bonusReleasedLastXDaysList.map((bonus) => {
                                                            return <div key={bonus.bonusCodes}
                                                                //  style={{ width: "100%", minHeight: "35px", display: 'flex', fontSize: "0.8rem", fontWeight: "500", color: "#032146", flexDirection: 'row', alignItems: 'center', justifyContent: "space-evenly" }}
                                                                className="bonusCodeName">
                                                                <div style={{ width: "30%", height: "100%", display: 'flex', justifyContent: "left", alignItems: "center" }}>{bonus.bonusCodes}</div>
                                                                <div style={{ width: "30%", height: "100%", display: 'flex', justifyContent: "center", alignItems: "center" }}>&#8377; {bonus.amount}</div>
                                                                <div style={{ width: "30%", height: "100%", display: 'flex', justifyContent: "right", alignItems: "center", whiteSpace: "nowrap" }}>{this.getFormattedDateAndTime(bonus.createdAt)}</div>
                                                            </div>
                                                        })}


                                                    </div>
                                                </div>}
                                            </div>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>}

                {/* End of Redeemable Amount Pop Up */}

                {/* My Wallet Content Container */}
                <div id="walletInfoContainer" className={this.state.transactionsActive ? 'walletInfoContainer maskedWallet' : this.state.isAdda ? "walletInfoContainerPokerAdda" :
                    this.state.isA23Poker ? "walletInfoContainerPokerA23" : 'walletInfoContainer'} style={{ backgroundColor: "" }} onClick={this.handleOutSideClick}>
                    {/* Loading Container */}
                    {/* walletInfoContainer */}
                    {this.state.isLoading ?
                        <div id="walletInfoContainerDiv" className="walletInfoContainer" >

                            {
                                this.state.enableHeader !== 'N' ?
                                    <nav className={this.state.isAdda ? "navbarAdda" :
                                        this.state.isA23Poker ? "navbarA23Poker" : 'navbar'
                                    }
                                        style={{ position: 'sticky', top: '0' }}>
                                        <div className={this.state.isAdda ? "nav-containerAdda" :
                                            this.state.isA23Poker ? "nav-containerA23Poker" : "nav-container"
                                        } >
                                            <img
                                                className='backBtn'
                                                id="myWallet_backBtn"
                                                src={!this.state.isOem ? navarrow : oemNavArrow}
                                                style={{ width: "40px" }}
                                                onClick={() => this.handleBackBtnClick({ type: "closeClient" })}
                                            />
                                            <p id="wt_walletHeader" className="" style={{ textAlign: 'center', fontSize: "1.1rem", fontWeight: "700", right: "" }}>My Wallet</p>
                                            <div></div>
                                        </div>
                                    </nav>
                                    :
                                    null
                            }
                            <div
                                // style={{
                                //     position: "absolute",
                                //     width: '100%',
                                //     height: '100vh',
                                //     top: 0,
                                //     background: '#FFFFFF',
                                //     display: 'flex',
                                //     alignItems: 'center',
                                //     justifyContent: 'center'
                                // }}
                                className="loadContainer">
                                <Loading />
                            </div>
                        </div>
                        :
                        <>

                            {/* HEADER TO GO BACK */}
                            {
                                this.state.enableHeader !== 'N' ?
                                    <nav className={this.state.isAdda ? "navbarAdda" :
                                        this.state.isA23Poker ? "navbarA23Poker" : 'navbar'
                                    }
                                        style={{ position: 'sticky', top: '0' }}>
                                        <div className="nav-container" >
                                            <img
                                                className='backBtn'
                                                id="myWallet_backBtn"
                                                src={!this.state.isOem ? navarrow : oemNavArrow}
                                                style={{ height: "40px" }}
                                                onClick={() => this.handleBackBtnClick({ type: "closeClient" })}
                                            />
                                            <p className="nav-text" style={{ textAlign: 'center', right: "-25px" }}>My Wallet</p>
                                            <div></div>
                                        </div>
                                    </nav>
                                    :
                                    null
                            }
                            <div id="walletInnerSection" className="walletInnerSection">

                                <div className="walletTopHalf">
                                    {/* Wallet Sections */}
                                    {/* border: 2px solid; */}

                                    {/* border-image-source: linear-gradient(180deg, rgba(74, 117, 188, 0.35) 26.34%, rgba(74, 117, 188, 0.35) 125.77%); */}


                                    <div id=""
                                        className={this.state.transactionsActive ? 'walletInfoContainer maskedWallet' : this.state.isAdda ? "wallet-section-containerAdda" :
                                            this.state.isA23Poker ? "wallet-section-containerPokerA23" : 'wallet-section-container'}
                                    // 'wallet-section-container' style={{
                                    // ,borderColor:"rgba(74, 117, 188, 0.35)"
                                    // }}
                                    >
                                        {
                                            (this.state.playerStatus === 'plocked') ?
                                                <div
                                                    className={this.state.isAdda ? 'total-balance-sectionAdda pseudo-wallet-section' :
                                                        this.state.isA23Poker ? 'total-balance-sectionPokerA23 pseudo-wallet-section' : 'total-balance-section pseudo-wallet-section'}
                                                // {'total-balance-section pseudo-wallet-section'}
                                                >
                                                    <div className='row space-between'>
                                                        <div className='section-heading'>
                                                            <span id="myWallet_totalBalanceHeading" className={this.state.isAdda ? "section-titleAdda" : 'section-title'}>Total Balance</span>
                                                            <img src={!this.state.isOem ? walletIcon : oemWalletIcon} style={{ width: '17px', marginLeft: '0.5rem' }}></img>
                                                        </div>
                                                        <span id="myWallet_totalUserBalance" className='pseudo'>
                                                            {
                                                                this.state.playerStatus === 'plocked' ?
                                                                    <img style={{ width: '9px', marginRight: '0.5rem' }} src={lock}></img>
                                                                    :
                                                                    null
                                                            }
                                                            &#8377;
                                                            {this.state.totalUserbalance.toFixed(2)}
                                                        </span>
                                                    </div>
                                                    <div className="pseudoContainer">
                                                        <span className="pseudo-subtitle">Add cash to unlock your balance</span>
                                                    </div>
                                                </div>
                                                :
                                                <div id="totalBalance"
                                                    className={this.state.isAdda ? 'total-balance-sectionAdda wallet-section' :
                                                        this.state.isA23Poker ? 'total-balance-sectionPokerA23 wallet-section' : 'total-balance-section wallet-section'}
                                                // {'total-balance-section pseudo-wallet-section'}
                                                // className={'total-balance-section wallet-section'}
                                                // style={{borderBottom:"1px solid rgba(74, 117, 188, 0.35)",marginTop:"1px"}}
                                                >
                                                    <div style={{ display: "flex", flexDirection: "column" }} >
                                                        {/* className='left' */}
                                                        {/* border: 2px solid; */}

                                                        {/* border-image-source: linear-gradient(180deg, rgba(74, 117, 188, 0.35) 26.34%, rgba(74, 117, 188, 0.35) 125.77%); */}


                                                        <span id="myWallet_totalUserBalance"
                                                            //this.state.isAdda ? 'total-balance-textPokerA23' :
                                                            //   this.state.isA23Poker ? 'total-balance-textPokerA23' : 
                                                            className={this.state.isAdda ? "total-balance-textAdda" : 'total-balance-text'}

                                                            style={{ fontSize: "1.5rem" }}>
                                                            &#8377;
                                                            {this.state.totalUserbalance.toFixed(2)}
                                                        </span>


                                                        <div className='section-heading' style={{ marginTop: "5%", marginBottom: "2px" }}>
                                                            <span id='myWallet_totalBalanceHeading' className={this.state.isAdda ? "section-titleAdda" : 'section-title'}>Total Balance</span>
                                                            <img src={!this.state.isOem ? walletIcon : oemWalletIcon} style={{ width: '15px', marginLeft: '0.5rem' }}></img>
                                                        </div>
                                                        {/* <div className='section-text'>
                                                            <span className='section-subtitle' style={{ whiteSpace: 'nowrap' }}>
                                                                {this.state.subscriptionType === "regular" ? "Add cash to start playing" : "Deposits + Bonus + Winnings"}
                                                            </span>

                                                        </div> */}
                                                    </div>
                                                    <div className='right'>
                                                        {/* <span id="myWallet_totalUserBalance" className='total-balance-text'>
                                                            &#8377;
                                                            {this.state.totalUserbalance.toFixed(2)}
                                                        </span> */}
                                                    </div>
                                                </div>
                                        }
                                        {/* <div
                                           
                                            className="deposits-section-wallet-section1">
                                           
                                               
                                        </div> */}
                                        {/* <div id='Bonus-Div-wallet-page'
                                           

                                            className="Bonus-Div-wallet-page">
                                            <div className='left' style={{ justifyContent: "flex-start", width: "75%", height: "100%" }}>
                                                <div className="total-balance-text" style={{}}>
                                                    <span id="myWallet_bonusCashAmount" className='cash' style={{ fontSize: "1.2rem", fontWeight: "900" }} >
                                                        &#8377;
                                                        {Number(this.state.bonusCash).toFixed(2)}
                                                    </span>
                                                </div>

                                                <div className='section-heading'>
                                                    <span id="myWallet_bonusCashHeading" className='section-title'
                                                    >Bonus</span>
                                                    <Tooltip
                                                        redeemProcessingFee={true}
                                                        tooltipArrow="tooltip-arrow"
                                                        direction={"bottom"}
                                                        content={<div style={{ display: 'flex', flexDirection: "column", width: '100%' }}>
                                                   
                                                            <div style={{ display: 'flex', width: '100%', flexDirection: "row", alignItems: "center", justifyContent: 'center' }}>
                                                               
                                                                <span>{"Instant Bonus + Unlocked Bonus"}</span>
                                                            </div>

                                                        </div>}
                                                    >
                                                        <img id="myWallet_balanceInfoIcon" src={!this.state.isOem ? infoIcon : oemInfoIcon} style={{ width: '15px' }}></img>
                                                    </Tooltip>
                                                </div>

                                                <div className='section-text'>
                                                    <span className='section-subtitle'
                                                    >
                                                        {this.state.bonusExpiryString}
                                                    </span>
                                                </div>


                                            </div>
                                        </div> */}

                                        {/* this.state.bonusConfiguredDays.toString() <= "0" ? */}


                                        {
                                            <div id='Winnings-wallet-page' style={{
                                                width: "95%", marginLeft: "10px", padding: "10px 0px", display: "flex",
                                                // boxShadow: '0px 1px 0px 0px #203253',
                                                // borderBottom: '1px solid #000000B2',
                                                ...(!this.state.showRedeemableBalanceInWalletInfo ? {} : '')
                                            }}>

                                                <div className='left' style={{ width: "75%" }} >
                                                    <div
                                                        //this.state.isAdda ? 'total-balance-textPokerA23' :
                                                        //   this.state.isA23Poker ? 'total-balance-textPokerA23' : 
                                                        className={this.state.isAdda ? 'total-balance-textAdda' : 'total-balance-text'}
                                                        //  className="total-balance-text"
                                                        style={{ marginBottom: "1%" }}>
                                                        <span id="myWallet_redeemBalanceAmount" className='cash deposits-section-title' style={{ fontSize: "1.2rem", fontWeight: "900" }}>
                                                            &#8377;
                                                            {console.log(this.state.redeembalance, "this.state.redeembalance")}
                                                            {Number(this.state.redeembalance).toFixed(2)}
                                                        </span>
                                                    </div>

                                                    <div className='section-heading'>
                                                        <span id="myWallet_redeemableHeading" className={this.state.isAdda ? "section-titleAdda" : 'section-title'}
                                                        //  style={{color:'#BABABA', fontWeight:'500', fontSize:'0.875rem' }}
                                                        // >Winnings</span>Withdraw Amount
                                                        >Withdrawable Amount</span>
                                                        {!this.state.showRedeemableBalanceInWalletInfo && <img id="myWallet_redeemableInfoIcon" onClick={this.handleRedeemInfo} src={!this.state.isOem ? infoIcon : oemInfoIcon} style={{ width: '15px', marginLeft: '0.5rem' }}></img>}                                                </div>

                                                    {!this.state.showRedeemableBalanceInWalletInfo && <div className='section-text' style={{ marginTop: '5%', width: '100%', height: '60%', display: 'flex', alignItems: 'center' }}>
                                                        <span className='section-subtitle'
                                                        >
                                                            Deposits + Winnings
                                                        </span>
                                                    </div>}
                                                    {console.log(this.state.totalPendingRedeems, "this.state")}
                                                    {/* { this.state.totalPendingRedeems > 0 && <div className='' style={{  marginTop: '5%', width: '100%', height: '60%', display: 'flex', alignItems: 'center' }}>
                                                    <span className="myLink" style={{ width: 'fit-content' }} onClick={() => this.props.history.push("/redeemhistory/")}>
                                                     View {this.state.totalPendingRedeems} pending redeems
                                                    </span>
                                                </div>
                                                } */}
                                                </div>
                                                {/* className='right' */}
                                                {/* style={{width:"45%",display:"flex",justifyContent:"center",alignItems:"center"}} */}
                                                <div style={{ width: "45%", display: "flex", justifyContent: "center", alignItems: "center" }} >

                                                    {!this.state.showRedeemableBalanceInWalletInfo && <div id="myWallet_redeemable_redeemBtn" className='btnDiv'>
                                                        {(this.state.subscriptionType === 'pseudo' || this.state.subscriptionType === 'regular') ?
                                                            // className='withdrawBtnDisabled btnStyle'
                                                            // <button id="wt_withdraw_button" onClick={() => this.props.toggleModalAction(true, <PremiumAccess />)}

                                                            //     className='withdrawBtn btnStyle'
                                                            // >
                                                            //     Withdraw
                                                            // </button>

                                                            //Made for balaji changes request

                                                            <button id="wt_redeem_button" onClick={() => {
                                                                WebToNativeMessage({ "type": "trackTime", "pageName": "Redeem click" })
                                                                this.handleWinningsCT()
                                                                this.checkForAdFlowEnabledStatus();
                                                            }}
                                                                className='withdrawBtn btnStyle'>
                                                                Withdraw
                                                                {/* commenting as the redeem redirection should happen after call back from native, depending on the ad */}
                                                                {/* <Link to={{ pathname: "/redeem/", token: window.sessionStorage["token"], from: "wallet" }}>Withdraw</Link> */}
                                                            </button>

                                                            :
                                                            // this.state.totalPendingRedeems > 0 ? <button onClick={() => this.handleWinningsCT()} className='withdrawBtn btnStyle'>
                                                            //     <Link to={{ pathname: "/redeemhistory/", from: "wallet" }}>Redeem</Link>
                                                            // </button> :
                                                            <button id="wt_redeem_button" onClick={() => {
                                                                WebToNativeMessage({ "type": "trackTime", "pageName": "Redeem click" })
                                                                this.handleWinningsCT();
                                                                this.checkForAdFlowEnabledStatus();
                                                            }}
                                                                className='withdrawBtn btnStyle'>
                                                                Withdraw
                                                                {/* commenting as the redeem redirection should happen after call back from native, depending on the ad */}
                                                                {/* <Link to={{ pathname: "/redeem/", token: window.sessionStorage["token"], from: "wallet" }}>Withdraw</Link> */}
                                                            </button>
                                                        }
                                                    </div>}
                                                </div>

                                            </div>
                                        }
                                        {this.state.showRedeemableBalanceInWalletInfo && <div
                                            // className="redeemableAmountSectionWinningsHolded"
                                            className={this.state.isAdda ? 'redeemableAmountSectionWinningsHoldedAdda' :
                                                this.state.isA23Poker ? 'redeemableAmountSectionWinningsHoldedPokerA23' : 'redeemableAmountSectionWinningsHolded'}
                                        >
                                            <div className="redeemableAmountGrid">
                                                <div className="left">
                                                    <div className='section-heading' style={{ margin: '0' }}>
                                                        <span id="myWallet_redeemableHeading" style={{ whiteSpace: 'nowrap' }} className={this.state.isAdda ? "section-titleAdda" : 'section-title'}>Withdrawable Amount</span>
                                                        <img id="myWallet_redeemableInfoIcon" src={!this.state.isOem ? infoIcon : oemInfoIcon} style={{ width: '15px', marginLeft: '0.5rem' }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    showRedeemableBalancePopUp: true
                                                                })
                                                            }}
                                                        ></img>
                                                    </div>
                                                    <div className={this.state.isAdda ? "section-textAdda" : 'section-text'} style={{ marginTop: '10px', width: '100%', height: '60%', display: 'flex', alignItems: 'center' }}>
                                                        {/* <span className='section-subtitle'>
                                                            (Winnings - Bonus given in Last {this.state.bonusReleasedLastXDays} {this.state.bonusReleasedLastXDays > 1 ? 'days' : 'day'})
                                                        </span> */}
                                                        <span id="myWallet_redeemBalanceAmount" style={{ fontSize: "1rem", color: this.state.isAdda ? "#24292e" : "#cfcfcf" }} className='cash'>
                                                            &#8377;
                                                            {this.state.redeemableAmount.toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="right" style={{ justifyContent: 'center' }}>
                                                    {/* <span id="myWallet_redeemBalanceAmount" className='cash deposits-section-title'>
                                                        &#8377;
                                                        {this.state.redeemableAmount.toFixed(2)}
                                                    </span> */}
                                                    <div id="myWallet_redeemable_redeemBtn" className='btnDiv'>
                                                        {(this.state.subscriptionType === 'pseudo' || this.state.subscriptionType === 'regular') ?
                                                            //  className='withdrawBtnDisabled btnStyle'
                                                            // <button id="wt_withdraw_button" onClick={() => this.props.toggleModalAction(true, <PremiumAccess />)}

                                                            //     className= {this.state.isAdda ? 'withdrawBtnAdda btnStyle': 'withdrawBtn btnStyle'}
                                                            // >
                                                            //     Withdraw
                                                            // </button>
                                                            <button id="wt_redeemcta" onClick={() => {
                                                                WebToNativeMessage({ "type": "trackTime", "pageName": "Redeem click" })
                                                                this.handleWinningsCT()
                                                            }
                                                            }
                                                                className='withdrawBtn btnStyle'>
                                                                <Link to={{ pathname: "/redeem/", token: window.sessionStorage["token"], from: "wallet" }}>Withdraw</Link>
                                                            </button>
                                                            :
                                                            // this.state.totalPendingRedeems > 0 ? <button onClick={() => this.handleWinningsCT()} className='withdrawBtn btnStyle'>
                                                            //     <Link to={{ pathname: "/redeemhistory/", from: "wallet" }}>Redeem</Link>
                                                            // </button> :
                                                            <button id="wt_redeemcta" onClick={() => {
                                                                WebToNativeMessage({ "type": "trackTime", "pageName": "Redeem click" })
                                                                this.handleWinningsCT()
                                                            }
                                                            }
                                                                className='withdrawBtn btnStyle'>
                                                                <Link to={{ pathname: "/redeem/", token: window.sessionStorage["token"], from: "wallet" }}>Withdraw</Link>
                                                            </button>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        </div>}


                                    </div>


                                    <div id="walletFunChipsContainer" className="walletFunChipsContainer" >

                                        <div id="walletFunChipsContainerLeft" className={this.state.isAdda ? "walletFunChipsContainerLeftAdda" : this.state.isA23Poker ? "walletFunChipsContainerLeftPokerA23" : "walletFunChipsContainerLeft"} >
                                            <div className="textAndIconDiv">
                                                <div className="funChipsDiv">
                                                    <span className={this.state.isAdda ? "funChipsTitleAdda" : "funChipsTitle"}>Fun Chips</span>
                                                    {/* <span className={this.state.isAdda ? "total-balance-textAdda":"total-balance-text"}>{ ( window.sessionStorage.getItem("pokerPlayBalance") && window.sessionStorage.getItem("pokerPlayBalance") !== null && window.sessionStorage.getItem("pokerPlayBalance") !== "null" && window.sessionStorage.getItem("pokerPlayBalance") !== "undefined" && window.sessionStorage.getItem("pokerPlayBalance") !== undefined  )  ? window.sessionStorage.getItem("pokerPlayBalance") : this.state.funBalance ? Number(this.state.funBalance).toFixed(2) : 0}</span> */}
                                                </div>
                                                <div id="iconContainer" className="iconContainer">
                                                    <img src={funChipsIcon} style={{ width: "45px" }}></img>
                                                </div>
                                            </div>



                                            {((window.sessionStorage.getItem("showWatchAds") === true) || (window.sessionStorage.getItem("showWatchAds") === "true")) && <div id="funChipsReload" className="funChipsReload">
                                                <img src={AddImg} style={{ width: "95%", height: "100%", display: "", opacity: "0" }}></img>
                                            </div>}


                                            {/* {Number(this.state.funBalance) < 0 && <div id="funChipsReload" className="funChipsReload">
                                                <img src={funChipsReload} style={{ width: "40%", height: "30px" }} onClick={() => {
                                                    try {
                                                        //https://javapi.qapfgames.com/JavaDynamo/reloadFunBal
                                                        let res =  axios({
                                                            method: "POST",
                                                            url: process.env.REACT_APP_TS_URL + "reloadFunBal",
                                                            headers: {
                                                                'authToken': window.sessionStorage.getItem('token')
                                                            },
                                                            data: {
                                                                id: window.sessionStorage.getItem('userid')
                                                                // channel: window.sessionStorage.getItem('channel'),
                                                            },

                                                        }).then((res) => {

                                                        console.log("java dynamo res>>>", res.data.funBal);
                                                        this.setState({funBalance: res.data.funBal})


                                                        })

                                                    } catch (error) {
                                                        console.log("error in fetchData2>>>", error)
                                                    }
                                                }}></img>
                                            </div>} */}


                                        </div>

                                        <div id="walletFunChipsContainerRight" className={this.state.isAdda ? "walletFunChipsContainerRightAdda" : this.state.isA23Poker ? "walletFunChipsContainerRightPokerA23" : "walletFunChipsContainerRight"} >
                                            <div className="textAndIconDiv">
                                                <div className="funChipsDiv">
                                                    <span className={this.state.isAdda ? "funChipsTitleAdda" : "funChipsTitle"}>Gems</span>
                                                    <span className={this.state.isAdda ? "total-balance-textAdda" : "total-balance-text"}>{this.state.gems}</span>
                                                </div>
                                                <div id="iconContainer" className="iconContainer">
                                                    <img src={gemsIcon} style={{ width: "45px" }}></img>
                                                </div>
                                            </div>
                                            {/* Number(this.state.funBalance) < 0 && */}
                                            {console.log("showWatchAds value>>>", window.sessionStorage.getItem("showWatchAds"))}
                                            {((window.sessionStorage.getItem("showWatchAds") === true) || (window.sessionStorage.getItem("showWatchAds") === "true")) && <div id="funChipsReload" className="funChipsReload" onClick={() => {
                                                WebToNativeMessage({ "type": "openAddWindow" })
                                            }}>
                                                <img src={AddImg} style={{ width: "95%", height: "100%", display: "", opacity: "1" }}></img>
                                            </div>}
                                        </div>

                                    </div>

                                    {this.state.totalPendingRedeems > 0 && <Link to={{ pathname: "/redeemhistory/", from: "wallet" }}>
                                        <div
                                            // className='transaction-history-link'
                                            className={this.state.isAdda ? 'transaction-history-linkAdda' :
                                                this.state.isA23Poker ? 'transaction-history-linkPokerA23' : 'transaction-history-link'}
                                            style={{ marginBottom: "12px" }} id="track_redeem_requests" onClick={
                                                () => {
                                                    const { profileData } = this.props.userState;
                                                    WebToNativeMessage(
                                                        {
                                                            type: "redeemCTEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
                                                                Click_Location: "Track Redeem Requests Wallet Page",
                                                                acelevel: this.state.aceLevel,
                                                                channel: window.sessionStorage["channel"],
                                                                subscriptionType: window.sessionStorage["subscriptionType"],
                                                                username: window.sessionStorage["screenName"],
                                                                count_pendingRedeem: profileData.totalPendingRedeems,
                                                                Source: 'Wallet Page'
                                                            }

                                                        })
                                                    WebToNativeMessage(
                                                        {
                                                            type: "mixpanelEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
                                                                Click_Location: "Track Redeem Requests Wallet Page",
                                                                acelevel: this.state.aceLevel,
                                                                channel: window.sessionStorage["channel"],
                                                                subscriptionType: window.sessionStorage["subscriptionType"],
                                                                username: window.sessionStorage["screenName"],
                                                                count_pendingRedeem: profileData.totalPendingRedeems,
                                                                Source: 'Wallet Page'
                                                            }

                                                        })
                                                    WebToNativeMessage({
                                                        type: "redeemCTEvent", eventName: "PF_c_Click_mywallet_viewalltransactions", eventProperties: {
                                                            aceLevel: this.state.aceLevel,
                                                            userID: this.state.userId,
                                                            subscriptionType: this.state.subscriptionType,
                                                            channel: window.sessionStorage["channel"],//this.state.channel,
                                                            wallet_balance: this.state.totalUserbalance,
                                                            username: this.state.screenName
                                                        }
                                                    })
                                                    this.setState({
                                                        transactionsActive: true
                                                    })
                                                }
                                            }>
                                            <div id="myWallet_transactionSummaryImgHeading" style={{ display: 'flex', alignItems: 'center' }}>
                                                <img style={{ width: '20px', height: 'auto' }} src={!this.state.isOem ? PendingRedeemIcon : oemPendingRedeemIcon}></img>
                                                <span id="wt_track_redeem_request_text" style={{ marginLeft: "5px" }}>Track Withdrawal Requests {"(" + this.state.totalPendingRedeems + ")"}</span>
                                            </div>
                                            <img id="myWallet_transactionSummary_navArrow" style={{ transform: 'rotate(180deg)', height: "30px" }} src={!this.state.isOem ? navarrow : oemNavArrow}></img>
                                        </div>
                                    </Link>}


                                    {/* Transaction History Link */}
                                    <Link id="wt_transaction_summary" to={{ pathname: "/transactionsummary/", from: "wallet" }}>
                                        <div
                                            className={this.state.isAdda ? 'transaction-history-linkAdda' :
                                                this.state.isA23Poker ? 'transaction-history-linkPokerA23' : 'transaction-history-link'}
                                            // className='transaction-history-link' 
                                            onClick={
                                                () => {
                                                    WebToNativeMessage({
                                                        type: "redeemCTEvent", eventName: "PF_c_Click_mywallet_viewalltransactions", eventProperties: {
                                                            aceLevel: this.state.aceLevel,
                                                            userID: this.state.userId,
                                                            subscriptionType: this.state.subscriptionType,
                                                            channel: window.sessionStorage["channel"],//this.state.channel,
                                                            wallet_balance: this.state.totalUserbalance,
                                                            username: this.state.screenName
                                                        }
                                                    })
                                                    this.setState({
                                                        transactionsActive: true
                                                    })
                                                }
                                            }>
                                            <div id="myWallet_transactionSummaryImgHeading" style={{ display: 'flex', alignItems: 'center' }}>
                                                <img style={{ width: '20px', height: 'auto' }} src={!this.state.isOem ? tstimer : oemTransactionIcon}></img>
                                                <span style={{ marginLeft: "5px", color: this.state.isAdda ? "#24292e" : "#cfcfcf" }}>Transaction Summary</span>
                                            </div>
                                            <img id="myWallet_transactionSummary_navArrow" style={{ transform: 'rotate(180deg)', height: "30px", color: this.state.isAdda ? "#24292e" : "#cfcfcf" }} src={!this.state.isOem ? navarrow : oemNavArrow}></img>
                                        </div>
                                    </Link>

                                    {/* AdSense Video Ad */}
                                    {console.log("wallet-video-ad container div created")}
                                    <AdBanner divId="wallet-video-ad" />

                                </div>

                                {/* Bottom Section */}
                                {/* <div id="myWalletBottomSection" className='my-wallet-bottom-section' >
                                   
                                    <div id="taxable-net-winnings-section" className='taxable-net-winnings-section' style={{
                                        display: (!this.state.showTaxableNetWin && Number(this.state.taxableRunningNetWin) <= 0) ? "none" : "inline-grid",
                                    }}>

                                        <div className='bottomTitleDiv'>
                                            <span id="taxable-net-winnings-title" className='locked-bonus-title' style={{ fontSize: "0.8rem" }}>
                                                {this.state.showRedeemableBalanceInWalletInfo ? 'Taxable Withdrawals' : 'Taxable Net Winnings'}
                                            </span>
                                        </div>
                                        <div className='middleDiv' id="taxable-net-winnings-amount-div" >
                                            {this.state.showTaxableNetWin ? <span id="taxable-net-winnings-amount" className='points'>
                                                &#8377;
                                                {Number(this.state.taxableRunningNetWin).toFixed(2) <= 0 ? 0.00 : Number(this.state.taxableRunningNetWin).toFixed(2)}
                                            </span> : <span id="taxable-net-winnings-amount" className='points'>
                                                &#8377;
                                                {Number(this.state.taxableRunningNetWin).toFixed(2)}
                                            </span>}
                                        </div>
                                        <div className="rightRedeemDiv" style={{ display: 'flex', alignItems: 'flex-end', width: "100%", justifyContent: "flex-end" }} >
                                            <div id="taxable-net-winnings-view-details" className="myLink" style={{ width: 'fit-content' }} onClick={() => {
                                                this.setState({
                                                    showTaxPopup: true
                                                })

                                                WebToNativeMessage({
                                                    type: "redeemCTEvent", eventName: "PF_taxablewinnings_bottomsheet_viewed", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })

                                                WebToNativeMessage({
                                                    type: "plotlineEvent", eventName: "PF_taxablewinnings_bottomsheet_viewed", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })

                                                WebToNativeMessage({
                                                    type: "mixpanelEvent", eventName: "PF_taxablewinnings_bottomsheet_viewed", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })


                                                WebToNativeMessage({
                                                    type: "redeemCTEvent", eventName: "PF_taxablewinnings_viewdetails_click", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })

                                                WebToNativeMessage({
                                                    type: "plotlineEvent", eventName: "PF_taxablewinnings_viewdetails_click", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })

                                                WebToNativeMessage({
                                                    type: "mixpanelEvent", eventName: "PF_taxablewinnings_viewdetails_click", eventProperties: {
                                                        Source: "Wallet Page", aceLevel: this.state.aceLevel, userID: this.state.userId, subscriptionType: this.state.subscriptionType, channel: window.sessionStorage["channel"], winnings_balance: this.state.redeembalance,
                                                        bonuscash_balance: this.state.bon,
                                                        locked_bonus: this.state.lockedbonus,
                                                        deposits_balance: this.state.deposits,
                                                        wallet_balance: this.state.totalUserbalance,
                                                        winnings_balance: this.state.redeembalance,
                                                        username: this.state.screenName,
                                                        tdsRefundConfig: this.state.tdsRefundConfig,
                                                        tdsRefundEligibility: this.state.tdsRefundEligibility,
                                                        tdsRefundAmount: this.state.tdsRefundAmount,
                                                        timestamp: new Date().getTime()
                                                    }
                                                })

                                            }}>View Details</div>
                                        </div>
                                    </div>
                                    {/* Netwinnings */}
                                {/* {<div className='ace-points-section'>
                                        <div className='bottomTitleDiv' onClick={() => this.handleAcePointsRedirection()}>
                                            <img id="myWallet_bottom_aceStarImg" style={{ width: '15px', marginRight: '0.5rem' }} src={assetChanges?.assets?.aceStar}></img>
                                            <span id="myWallet_bottom_acePointsText" className='locked-bonus-title'>
                                                {this.state.isOem ? "Black Points" : "Ace Points"}
                                            </span>
                                            <img id="myWallet_bottom_acePointsInfoIcon" src={!this.state.isOem ? infoIcon : oemInfoIcon} style={{ width: '15px', marginLeft: '0.5rem' }}></img>
                                        </div>
                                        <div className='middleDiv'>
                                            <span id="myWallet_bottom_currentTotalAcePoints" className='points'>
                                                {redeemAcePointsDetails && redeemAcePointsDetails?.currentTotalAcePoints ? redeemAcePointsDetails.currentTotalAcePoints : 0}
                                            </span>
                                        </div>
                                        <div className="rightRedeemDiv" onClick={() => {
                                            this.setState({
                                                showRedeemAceLevelModal: true
                                            })
                                        }}>
                                            <span className='myLink right'>
                                                <div>
                                                    <Tooltip
                                                        redeemEducate={true}
                                                        direction={"left"}
                                                        content={`Redeem your acepoints without adding cash`}
                                                        initialShow={
                                                            (
                                                                JSON.parse(window.localStorage['acepoints-redeem-object']).filter(item => item.username === window.sessionStorage["screenName"])[0].count <= 3
                                                            ) ? true : false
                                                        }
                                                    >
                                                        <span id="myWallet_bottom_redeemBtn" className={"myLink"}>Redeem</span>
                                                    </Tooltip>
                                                </div>

                                            </span>

                                        </div>
                                    </div>} */}

                                {/* <div className='locked-bonus-section' style={{display : window.sessionStorage.getItem("channel").toLowerCase() ==="oemaps1" ? "none":"grid"}}> */}
                                {/* <div className='locked-bonus-section' style={{ display: "grid" }}>
                                        <div className='bottomTitleDiv'>
                                            <span id='myWallet_bottom_lockedBonusText' className='locked-bonus-title'>
                                                Locked Bonus
                                            </span>
                                        </div>
                                        <div className='middleDiv'>
                                            <span id='myWallet_bottom_pendingBonus' className='cash middle'>
                                                &#8377;
                                                {this.state.pendingBonus.toFixed(2)}
                                            </span>
                                        </div>
                                        <div className="rightRedeemDiv">
                                            <div style={{ display: 'flex', alignItems: 'flex-end' }} onClick={() => {
                                                WebToNativeMessage({
                                                    type: "redeemCTEvent", eventName: "PF_c_Click_mywallet_knowmore_Lockedbonus", eventProperties: {
                                                        userID: this.state.userId,
                                                        subscriptionType: this.state.subscriptionType,
                                                        channel: window.sessionStorage["channel"],//this.state.channel,
                                                        wallet_balance: this.state.userBalance,
                                                        username: this.state.screenName
                                                    }
                                                })
                                            }} className='right'>
                                                <div id='myWallet_bottom_knowMoreLink' className="myLink" style={{ width: 'fit-content' }} onClick={() => this.props.history.push('/bonussummary/')}>Know More</div>
                                            </div>
                                        </div>
                                    </div> */}

                                {/* {

                                        
                                        (this.state.bonusToBeExpired.amount !== null && this.state.expiryDaysLeft !== null) ?
                                            (
                                                (this.state.expiryDaysLeft >= 1) ?
                                                    <div className="red-text" style={{ display: 'flex', justifyContent: 'center', height: '30px' }}>
                                                        <span>&#8377;{this.state.bonusToBeExpired.amount} expires in {this.state.expiryDaysLeft} {this.state.expiryDaysLeft>1?"Days":"Day"}</span>
                                                    </div>
                                                    :
                                                    <div className="red-text" style={{ display: 'flex', justifyContent: 'center', height: '30px' }}>
                                                        <span>&#8377;{this.state.bonusToBeExpired.amount} expires within {new Date(this.state.bonusToBeExpired.expiryAt).toLocaleTimeString()}.</span>
                                                    </div>
                                            )
                                            :
                                            null
                                    } */}
                                {/* </div> */}
                                {this.state.showRedeemAceLevelModal && <><div className={this.state.showRedeemAceLevelModal ? "redeem-ace-points-modal-mask-container" : "redeem-ace-points-modal-hidden-mask-container"} onClick={() => this.setState({ showRedeemAceLevelModal: false })} ></div>
                                    <div className={this.state.showRedeemAceLevelModal ? this.state.redeemAcePointsKeyboardOpen ? 'redeem-ace-level-modal-open-keyboard-open' : 'redeem-ace-level-modal-open-default' : 'redeem-ace-level-modal'}>
                                        <div className={'redeem-ace-level-header'}>
                                            <span className={'redeem-heading-text'}>
                                                {!this.state.isOem ? "Redeem Ace Points" : "Redeem Black Points"}
                                            </span>
                                            <img className={'close-icon'} src={CloseIcon} onClick={() => {
                                                this.setState({
                                                    showRedeemAceLevelModal: false
                                                })
                                            }} />
                                        </div>
                                        <div className="redeem-ace-level-body" >
                                            <div className={'ace-points-wrapper'}>
                                                <img className={'acepoints-star-icon'} src={assetChanges.assets?.AcePointsStarIcon} />
                                                <div className="ace-points-content-wrapper" >
                                                    <div className="ace-points-container" >
                                                        <span className={'ace-points-text'}>{!this.state.isOem ? "Ace Points Balance" : "Black Points Balance"}</span>
                                                        <span className={'ace-points-number-text'}>{redeemAcePointsDetails && redeemAcePointsDetails?.currentTotalAcePoints ? redeemAcePointsDetails.currentTotalAcePoints : 0}</span>
                                                    </div>
                                                    <div className={'ace-points-description-wrapper'} >
                                                        <span className={'ace-points-description-text'}>{!this.state.isOem ? "Acepoints" : "Blackpoints"} can be redeemed for Bonus cash.</span>
                                                        <span className={'ace-points-description-text'}>{redeemAcePointsDetails?.convertAcePts} {!this.state.isOem ? "Ace Points" : "Black Points"} = ₹{redeemAcePointsDetails?.convertCashValue} Bonus Cash</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={'ace-points-body'}>
                                                <input
                                                    name="redeemamount"
                                                    type="tel"
                                                    id="redeemamount"
                                                    min="0"
                                                    disabled={redeemAcePointsDetails.currentTotalAcePoints < redeemAcePointsDetails.minRedeemableValue || redeemAcePointsDetails.maxRedeemableValue < redeemAcePointsDetails.minRedeemableValue}
                                                    value={this.state.acePointsToConvert}
                                                    placeholder={!this.state.isOem ? 'Enter Ace Points to convert' : 'Enter Black Points to convert'}
                                                    className="redeem-ace-points-input "
                                                    //   value={this.state.redeemamount}
                                                    maxLength='10'
                                                    // pattern="[0-9]"
                                                    onChange={(e) => {
                                                        const re = /^\d+$/

                                                        if (re.test(e.target.value) || e.target.value === '') {
                                                            // const value = e.target.value.replace(/^0+/, '').slice(0, max.toString().length <= 0 ? 2 : max.toString().length);
                                                            // setEnteredAmount(value)

                                                            const value = e.target.value.replace(/^0+/, '');
                                                            this.handleAcePointsChange(value)
                                                        }

                                                    }}
                                                    onFocus={!(redeemAcePointsDetails.currentTotalAcePoints < redeemAcePointsDetails.minRedeemableValue || redeemAcePointsDetails.maxRedeemableValue < redeemAcePointsDetails.minRedeemableValue) ? this.handleAcePointsFocusChange : () => { }}
                                                    onBlur={!(redeemAcePointsDetails.currentTotalAcePoints < redeemAcePointsDetails.minRedeemableValue || redeemAcePointsDetails.maxRedeemableValue < redeemAcePointsDetails.minRedeemableValue) ? this.handleAcePointsBlurChange : () => { }}
                                                    //   onKeyUp={e => this.onKeyUp(e)}
                                                    autoComplete="off"
                                                    onPaste={(e) => {
                                                        e.preventDefault()
                                                        return false;
                                                    }} onCopy={(e) => {
                                                        e.preventDefault()
                                                        return false;
                                                    }}
                                                //PL-4919 Issue Fix

                                                >
                                                </input>
                                                {
                                                    // this.state.aceLevel !== 'platinum+' ?
                                                    //     <span className="input-placeholder2">
                                                    //         {`Upto ${redeemAcePointsDetails.redeemLimit - redeemAcePointsDetails.acePointsRedeemedInCurrentLevel || 0}`}
                                                    //     </span>
                                                    //     :
                                                    //     <span className="input-placeholder2">{'Unlimited'}</span>
                                                    ((redeemAcePointsDetails.currentTotalAcePoints < redeemAcePointsDetails.minRedeemableValue || redeemAcePointsDetails.maxRedeemableValue < redeemAcePointsDetails.minRedeemableValue) && redeemAcePointsDetails.currentAceLevel !== 0) ?
                                                        <span className="input-placeholder2">{`${redeemAcePointsDetails.redeemLimits[redeemAcePointsDetails.currentAceLevelName].min + '-' + redeemAcePointsDetails.redeemLimits[redeemAcePointsDetails.currentAceLevelName].min}`}</span>
                                                        : redeemAcePointsDetails.maxRedeemableValue === redeemAcePointsDetails?.minRedeemableValue ?
                                                            <span className="input-placeholder2">
                                                                {`Upto ${redeemAcePointsDetails?.minRedeemableValue}`}
                                                            </span>
                                                            :
                                                            <span className="input-placeholder2">{`${redeemAcePointsDetails.minRedeemableValue + '-' + Math.min(Number(redeemAcePointsDetails.maxRedeemableValue), Number(redeemAcePointsDetails.currentTotalAcePoints))}`}</span>

                                                }
                                                {/* {redeemAcePointsDetails.currentTotalAcePoints !== null && redeemAcePointsDetails.currentTotalAcePoints !== undefined && redeemAcePointsDetails.currentTotalAcePoints === 0 ?
                                                <span className={'redeem-ace-points-exceed-limit-text'}>You have no acepoints to redeem.</span> :
                                                this.state.showAcePointsValueMultiplesError ?
                                                    <span className={'redeem-ace-points-error-note-text'}>*Note: Acepoints value should be in multiples of 100</span>

                                                    : this.state.showInsufficientAcePoints ? <span className={'redeem-ace-points-exceed-limit-text'}>Your acepoints entered exceeds your present acepoints balance. Please enter a different value & try again</span> :
                                                        this.state.showAcePointsLimitExceeded ?
                                                            <span className={'redeem-ace-points-exceed-limit-text'}>The value entered exceeds your monthly quota to redeem acepoints. Please check your redeem limit & try again</span>
                                                            :

                                                            // null
                                                            <span className={'redeem-ace-points-note-text'}>*Note: Acepoints value should be in multiples of 100</span>
                                            }
                                             */}

                                                {this.handleAcePointsErrorMessage(this.state.acePointsToConvert)}


                                                <div className="redeem-ace-points-you-get-wrapper">
                                                    <div className={'you-get-text-wrapper'}>
                                                        <span className="you-get-text">You Get Bonus Cash</span>
                                                        <Tooltip
                                                            redeemAcePoints={true}
                                                            tooltipArrow="tooltip-arrow"
                                                            direction={"bottom"}
                                                            content={
                                                                `
                                                            Bonus cash will be added to your wallet and can be used only to play games.
                                                        `}
                                                        >
                                                            <img className="info-icon" src={!this.state.isOem ? InfoIcon : oemInfoIcon} />
                                                        </Tooltip>

                                                    </div>
                                                    <span className="conversion-amount-text">{this.getAcePointsConversionAmount(redeemAcePointsDetails)}</span>
                                                </div>
                                            </div>

                                            <div className={'ace-points-footer'}>
                                                <button onClick={this.handleAcePointsClaim} className={'claim-button'} disabled={!this.state.enableAcePointsClaimButton}>
                                                    <span className={'claim-button-text'}  >
                                                        Claim
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                }

                                {this.state.showAcePointsRedeemSuccessModal && <div className="claim-success-container">
                                    <div className="claim-success-wrapper">
                                        <div className="claim-success-header">
                                            <span className="confirmation-text">Ace Points Redeemed</span>
                                            <img className={'close-icon'} src={CloseIcon} onClick={() => {
                                                this.setState({
                                                    showAcePointsRedeemSuccessModal: false
                                                })
                                            }} />

                                        </div>
                                        <div className="claim-success-body" >
                                            <img className="claim-success-celebrate-icon" src={SuccessIcon} />
                                            <span className="congratulations-text">
                                                Successful
                                            </span>

                                            <span className="claim-success-note-text">
                                                {redeemAcePointsDetails && redeemAcePointsDetails?.claimSuccessMessage}
                                                {/* We have added <span className="claim-success-amount-text"> ₹146.00</span> to your A23 Wallet. */}
                                            </span>
                                            <button className="play-now-button"
                                                onClick={() => this.handleBackBtnClick({ type: "closeClient" })}
                                            >OK</button>
                                        </div>
                                    </div>
                                </div>}
                            </div>

                        </>}
                    {this.state.openRedeemAcepointsInfoPopUp && this.createRedeemAcepointsInfoPopUp()}

                </div>
                {/* End of My Wallet Content Container */}

            </div >
            // End of entire wallet
        )
    }
}
WalletInfoRevamp.contextType = UserContext;

const mapStateToProps = state => ({
    userState: state.userState
});

export default connect
    (mapStateToProps, { toggleAlertAction, toggleModalAction, getUserProfileAction, getPokerAmountTDSInfo, pokerAmountToA23Transfer, a23ToPokerAmountTransfer, fetchRedeemAcePointsData, submitClaimRedeemAcePoints })(WalletInfoRevamp);